
export const thingsToDoArr = [
    

]

export const newVideos = [

    {
        "title": "Рынок Махане-Иегуда",
        // "sml_desc": "Праздник для всех<br> органов чувств",
        "sml_desc": "",
        // "desc": "Прочувствуйте всю прелесть этого рынка - картинки, звуки, запахи и, разумеется, вкусы",
        "desc": "",
        "img": "Videos/market-madness.jpg",
        "img_mob":"/Videos/video_mob/market-madness.jpg",
        "side_img": "Videos/sidebar/market-madness.jpg",
        "read_more": "Прочитать больше",
        "link": "/Posts/index.php?post=Market_Madness",
        "vidId": "2CSCe2WC7Ns",
        "ctg": "culinaryjerusalem",
        "isVid": true,
        "forVidPage": true,
        "id": "Market_Madness"
    },

     // this Video post is going to the same post as "title": "Amazing Nightlife" Eyal Asked
    {
        "title": "Окунитесь в бурную ночную жизнь",
        // "sml_desc": "Забронируйте поездку в Тель-Авив уже сейчас!",
        "sml_desc": "",
        // "desc": "Хотели бы окунуться в бурную ночную жизнь?",
        "desc": "",
        "img": "Videos/crazy-night.jpg",
        "img_mob":"/Videos/video_mob/crazy-night.jpg",
        "side_img": "Videos/sidebar/crazy-night.jpg",
        "read_more": "Прочитать больше",
        "link": "/Posts/index.php?post=Amazing_Nightlife",
        "vidId": "ogEN7aRT0SM",
        "ctg": "telaviv",
        "isVid": true,
        "forVidPage": true,
        "id": "Amazing_Nightlife"
    },
    // END this Video post is going to the same post as "title": "Amazing Nightlife" Eyal Asked

    {
        "title": "Иерусалим",
        // "sml_desc": "Иерусалим - сердце целого мира",
        "sml_desc": "",
        // "desc": "",
        "desc": "",
        "img": "Videos/heart-of-the-world.jpg",
        "img_mob":"/Videos/video_mob/heart-of-the-world.jpg",
        "side_img": "Videos/sidebar/heart-of-the-world.jpg",
        "read_more": "Прочитать больше",
        "link": "/Posts/index.php?post=Heart_Of_The_World",
        "vidId": "nLKWDp5uA-U",
        "ctg": "jerusalem",
        "isVid": true,
        "forVidPage": true,
        "id": "Heart_Of_The_World"
    },

    {
        "title": "2 УДИВИТЕЛЬНЫХ ГОРОДА",
        // "sml_desc": "Один солнечный отпуск",
        "sml_desc": "",
        "desc": "",
        "img": "/PostCarousel/Jerusalem/tw-awesome-cities.jpg",
        "side_img": "/PostCarousel/Jerusalem/tw-awesome-cities.jpg",
        "read_more": "Прочитать больше",
        "link": "/Posts/index.php?post=2_AWESOME_CITIES",
        "isVid": true,
        "forVidPage": true,
        "vidId": "NlOJ-i5hJdI",
        "ctg": "telavivAndJerusalem",
        "id": "2_AWESOME_CITIES"
    },
    {
       "title": "ВЕЧНЫЙ ГОРОД",
        "sml_desc" : "",
         "desc" : "",
        "img": "/PostCarousel/Jerusalem/jerusalem.jpg",
        "side_img": "/PostCarousel/Jerusalem/jerusalem.jpg",
        "read_more": "Прочитать больше",
        "link": "/Posts/index.php?post=Jerusalem",
        "isVid": true,
        "forVidPage": true,
        "vidId": "FvAWuLQEOJw",
        "ctg": "jerusalem",
        "id": "Jerusalem"
    },
    {
        "title": "МЕРТВОЕ МОРЕ",
        // "sml_desc": "TAKE RELAXATION TO THE NEXT LEVEL",
        "sml_desc": "",
        "desc": "",
        "img": "/PostCarousel/DeadSea/next-level.jpg",
        "side_img": "/PostCarousel/DeadSea/next-level.jpg",
        "read_more": "Прочитать больше",
        "link": "/Posts/index.php?post=Next_Level_DS",
        "isVid": true,
        "forVidPage": true,
        "vidId": "9aDP-jV6soE",
        "ctg": "deadsea",
        "id": "Next_Level_DS"
    },
    {
        "title": "ТЕЛЬ-АВИВ",
        "sml_desc": "",
        "desc": "",
        "img": "/PostCarousel/TelAviv/post-telaviv.jpg",
        "side_img": "/PostCarousel/TelAviv/post-telaviv.jpg",
        "read_more": "Прочитать больше",
        "link": "/Posts/index.php?post=Tel_Aviv",
        "isVid": true,
        "forVidPage": true,
        "vidId": "PdTkXbiBpFs",
        "ctg": "telaviv",
        "id": "Tel_Aviv"
    },
    
    {
        "title": "ПРЕЛЕСТИ МЁРТВОГО МОРЯ",
        // "sml_desc": "Для бесконечно приятного времяпрепровождения",
        "sml_desc": "",
        "desc": "",
        "img": "/PostCarousel/DeadSea/deadsea2.jpg",
         "img_mob":"/PostCarousel/video_mob/100.jpg",
        "side_img": "/PostCarousel/DeadSea/deadsea2.jpg",
        "read_more": "Прочитать больше",
        "link": "/Posts/index.php?post=Dead_Sea2",
        "isVid": true,
        "forVidPage": true,
        "vidId": "9aDP-jV6soE",
        "ctg": "deadsea",
        "id": "Dead_Sea2"
    },
   
    {
        // "title": "A Foodie’s Paradise‘",
        "title" : "Просто восхитительный вкус",
        // "sml_desc": "Сотни знаменитых ресторанов, удивительные <br> продукты и вкусная уличная еда",
        "sml_desc": "",
        // "desc": "Настоящий рай <br>для гурманов",
        "desc": "",
        "img": "/PostCarousel/99.jpg",
        "img_mob":"/PostCarousel/video_mob/99.jpg",
        "side_img": "/PostCarousel/99.jpg",
        "read_more": "Прочитать больше",
        "link": "/Posts/index.php?post=21",
        "ctg": "culinarytelaviv",
        "vidId": "n4kCnPXEX7g",
        "isVid": true,
        "forVidPage": true,
        "id": "Simply_Delicious"
    },
    {
        "title": "Иерусалимские сюрпризы",
        // "sml_desc": "Город превосходящий ожидания",
        "sml_desc": "",
        "desc": "",
        "img": "/PostCarousel/38.jpg",
        "side_img": "/PostCarousel/38.jpg",
        "read_more": "Прочитать больше",
        "link": this.url + "/Posts/index.php?post=Cool Jerusalem",
        "ctg": "jerusalem",
        "isVid": true,
        "forVidPage": true,
        "vidId":"nLKWDp5uA-U",
        "id": "Cool_Jerusalem"
    },
    {
       "title": "МЕРТВОЕ МОРЕ",
        "sml_desc" : "",
        "desc" : "",
        "img": "/PostCarousel/DeadSea/magical-deadsea.jpg",
        "side_img": "/PostCarousel/DeadSea/magical-deadsea.jpg",
        "read_more": "Прочитать больше",
        "link": "/Posts/index.php?post=Magical_Deadsea",
        "isVid": true,
        "forVidPage": true,
        "vidId": "9aDP-jV6soE",
        "ctg": "deadsea",
        "id": "Magical_Deadsea"
    },
    {
        "title": "УДИВИТЕЛЬНАЯ НОЧНАЯ ЖИЗНЬ",
        "sml_desc": "",
        // "sml_desc": "УДИВИТЕЛЬНАЯ НОЧНАЯ ЖИЗНЬ",
        "desc": "",
        // "desc": "Вечеринка нон-стоп в городе, котрый никогда не спит",
        "img": "/PostCarousel/TelAviv/amazing-nightlife.jpg",
        "side_img": "/PostCarousel/TelAviv/amazing-nightlife.jpg",
        "read_more": "Прочитать больше",
        "link": "/Posts/index.php?post=Amazing_Nightlife",
        "isVid": true,
        "forVidPage": true,
        "vidId":"ogEN7aRT0SM",
        "ctg": "telaviv",
        "id": "Amazing_Nightlife"
    },
    
     
    {
        "title": "ВОЛШЕБНЫЙ ЯФФО",
        // "sml_desc": "ЯФФА: Город, чарующий <Br/> культурным многообразием",
        "sml_desc": "",
        // "desc": "Откройте для себя <Br/> сокровища прекрасной древней Яффы",
        "desc": "",
        "img": "Videos/magic-jaffa.jpg",
        "img_mob":"/Videos/video_mob/magic-jaffa.jpg",
        "side_img": "Videos/sidebar/magic-jaffa.jpg",
        "read_more": "Прочитать больше",
        "link": "/Posts/index.php?post=Magic_JAffa",
        "vidId": "FRmgXjfVPoE",
        "ctg": "telaviv",
        "isVid": true,
        "forVidPage": true,
        "id": "Magic_JAffa"
    },

    
    {
        "title": "Яркие моменты Тель-Авива",
        // "sml_desc": "Топ-5 вещей, которые стоит <br>увидеть и сделать в городе",
         "sml_desc": "",
        "desc": "",
        "img": "/PostCarousel/17.jpg",
        "side_img": "/PostCarousel/17.jpg",
        "read_more": "Прочитать больше",
        "link": "/Posts/index.php?post=17",
        "ctg": "telaviv",
        "isVid": true,
        "forVidPage": true,
        "vidId": "F6n-WK0RHk0",
        "id": "TelAviv_Moments"
    },
    
    {
        "title": "Попробуйте в Иерусалиме",
        // "sml_desc": "Обязательно попробовать в Иерусалиме",
        "desc": "",
        "sml_desc": "",
        "img": "/PostCarousel/37.jpg",
         "img_mob":"/PostCarousel/video_mob/37.jpg",
        "side_img": "/PostCarousel/37.jpg",
        "read_more": "Прочитать больше",
        "link": "/Posts/index.php?post=38",
        "ctg": "culinaryjerusalem",
        "vidId": "2CSCe2WC7Ns",
        "isVid": true,
        "forVidPage": true,
        "id": "A_Taste_Of_Jerusalem"
    },
    
    {
       "title": "ГАСТРОНОМИЧЕСКИЕ ДОСТОПРИМЕЧАТЕЛЬНОСТИ",
        "sml_desc" : "",
         "desc" : "",
        "img": "/PostCarousel/TelAviv/gastronomic-atractions-telaviv.jpg",
        "side_img": "/PostCarousel/TelAviv/gastronomic-atractions-telaviv.jpg",
        "read_more": "Прочитать больше",
        "link": "/Posts/index.php?post=Gastronomic_Atractions_Telaviv",
        "isVid": true,
        "forVidPage": true,
        "vidId":"jfyHxk8ZRrI",
        "ctg": "telaviv",
        "id": "Gastronomic_Atractions_Telaviv"
    },
    
    {
       "title": "БУЛЬВАР МАМИЛА",
        "sml_desc" : "",
        "desc" : "",
        "img": "/PostCarousel/Jerusalem/mamila-avenue.jpg",
        "side_img": "/PostCarousel/Jerusalem/mamila-avenue.jpg",
        "read_more": "Прочитать больше",
        "link": "/Posts/index.php?post=Mamilla_Avenue",
        "isVid": true,
        "forVidPage": true,
        "vidId": "nX9LnWAjOIY",
        "ctg": "jerusalem",
        "id": "Mamilla_Avenue"
    },
   
    {
        "title": "ПРИМОРСКИЙ ТЕЛЬ-АВИВ",
        // "sml_desc": "Потому что Тель-Авив <Br/>невозможно представить без пляжей ",
        "sml_desc": "",
        // "desc": "Не сомневайтесь, вы получите огромное<br> удовольствие на солнышке",
        "desc": "",
        "img": "Videos/a.jpg",
        "img_mob":"/Videos/video_mob/a.jpg",
        "side_img": "Videos/sidebar/a.jpg",
        "read_more": "Прочитать больше",
        "link": "/Posts/index.php?postType=video&post=3",
        "css_class": "unic_video-post-4",
        "vidId": "PdTkXbiBpFs",
        "ctg": "telaviv",
        "isVid": true,
        "forVidPage": true,
        "id": "TelAviv_By_The_Sea"
    },
   
    
    {
        "title": "Неве Цедек",
        "sml_desc": "",
        // "sml_desc" : "Шик и <br>уникальность  ",
        // "desc": "Множество уютных кафе, бутиков, галерей<br> и расслабленная атмосфер",
         "desc": "",
        "img": "Videos/j.jpg",
        "img_mob":"/Videos/video_mob/j.jpg",
        "side_img": "Videos/sidebar/j.jpg",
        "read_more": "Прочитать больше",
        "vidId": "F6n-WK0RHk0",
        "link": "/Posts/index.php?postType=video&post=7",
        "css_class": "unic_video-post-13",
        "ctg": "telaviv",
        "isVid": true,
        "forVidPage": true,
        "id": "Neve_Tzedek"
    },
    {
       "title": "КУХНЯ ИЕРУСАЛИМА",
        "sml_desc" : "Разнообразие вкусных блюд",
        "desc" : "",
        "img": "/PostCarousel/Jerusalem/jerusalem-kitchen.jpg",
        "side_img": "/PostCarousel/Jerusalem/jerusalem-kitchen.jpg",
        "read_more": "Прочитать больше",
        "link": "/Posts/index.php?post=Jerusalem-Kitchen",
        "css_class": "unic_video-post-jerusalem-kitchen",
        "isVid": true,
        "forVidPage": true,
        "vidId": "2CSCe2WC7Ns",
        "ctg": "jerusalem",
        "id": "Jerusalem_Kitchen"
    },

   
    {
        "title": "Шоппинг в удовольствие",
        // "sml_desc": "От модной одежды до <br>сувениров – все это в Иерусалиме",
        "sml_desc": "",
        "desc": "",
        "img": "/PostCarousel/5.jpg",
        "side_img": "/PostCarousel/5.jpg",
        "read_more": "Прочитать больше",
        "link": "/Posts/index.php?post=Shopping_Delights",
        "ctg": "jerusalem",
        "isVid": true,
        "forVidPage": true,
        "vidId":"nX9LnWAjOIY",
        "id": "Shopping_Delights"
    },
  

    {
        "title": "ТЕЛЬ-АВИВ ДЛЯ ВЕГЕТАРИАНЦЕВ",
        // "sml_desc": "Лучшие вегетарианские рестораны Тель-Авива",
        "sml_desc": "",
        "desc": "",
        "img": "/PostCarousel/6.jpg",
        "side_img": "/PostCarouse/6.jpg",
        "read_more": "Прочитать больше",
        "link": "/Posts/index.php?post=Vegan_Friendly_TelAviv_Post",
        "ctg": "telaviv",
        "isVid": true,
        "forVidPage": true,
        "vidId": "Tub5VbKN4lQ",
        "id": "Vegan_Friendly_TelAviv_Post"
    },
 
    
    
    {
        "title": "Сарона в Тель-Авиве",
        "desc": "",
        // "desc": "Великолепный оазис в <br>урбанистическом окружении",
        // "sml_desc": "Множество интересного<Br/> в реставрированной колонии темплеров",
        "sml_desc": "",
        "img": "Videos/d.jpg",
        "img_mob":"/Videos/video_mob/d.jpg",
        "side_img": "Videos/sidebar/d.jpg",
        "read_more": "Прочитать больше",
        "link": "/Posts/index.php?postType=video&post=Sarona_TelAviv",
        "vidId": "bWY_8bHq3as",
        "ctg": "telaviv",
        "isVid": true,
        "forVidPage": true,
        "id": "Sarona_TelAviv"
    },
    {
       "title": "ИЕРУСАЛИМСКИЕ ВОРОТА",
        "sml_desc" : "",
        "desc" : "",
        "img": "/PostCarousel/Jerusalem/gates.jpg",
        "side_img": "/PostCarousel/Jerusalem/gates.jpg",
        "read_more": "Прочитать больше",
        "link": "/Posts/index.php?post=The_Gates_Of_Jerusalem",
        "isVid": true,
        "forVidPage": true,
        "vidId":"MXtcTm_JXus",
        "ctg": "jerusalem",
        "id": "The_Gates_Of_Jerusalem"
    },
    
    
    {
        "title": "Центр кулинарного искусства",
        // "sml_desc": "Пробудите свои вкусовые<br> рецепторы в Тель-Авиве",
        "sml_desc": "",
        // "desc": "Тель-Авив предлагает огромный<br> выбор великолепных ресторанов",
        "desc": "",
        "img": "Videos/e.jpg",
        "img_mob":"/Videos/video_mob/e.jpg",
        "side_img": "Videos/sidebar/e.jpg",
        "read_more": "Прочитать больше",
        "link": "/Posts/index.php?postType=video&post=33",
        "vidId": "jfyHxk8ZRrI",
        "ctg": "culinarytelaviv",
        "isVid": true,
        "forVidPage": true,
        "id": "Gourmet_TelAviv"
    },
    
    {
        "title": "Тель-Авив",
        // "desc": "Велосипедные путешествия Тель-Авивом",
        "sml_desc": "",
        "desc": "",
        "img": "PostCarousel/39.jpg",
        "side_img": "PostCarousel/39.jpg",
        "read_more": "Прочитать больше",
        "link": "/Posts/index.php?post=39",
        "ctg": "telaviv",
        "isVid": true,
        "forVidPage": true,
        "vidId": "88OV6xU0vPI",
        "id": "TelAviv_Cycle"
    },
    {
        "title": "ОБЯЗАТЕЛЬНО В ИЕРУСАЛИМЕ",
        // "sml_desc": "5 самых популярных вещей, которые нужно сделать, и мест, которые вы должны увидеть в потрясающем городе",
        "sml_desc": "",
        "desc": "",
        "img": "/PostCarousel/18.jpg",
        "side_img": "/PostCarousel/18.jpg",
        "read_more": "Прочитать больше",
        "link": "/Posts/index.php?post=Jerusalem_Musts",
        "isVid": true,
        "forVidPage": true,
        "vidId": "WVGEqXhtipI",
        "ctg": "jerusalem",
        "id": "Jerusalem_Musts"
    },


    {
        "title": "Рай для гурмана",
        // "sml_desc": "Познакомьтесь с удивительной <br>кулинарной сценой Тель-Авива",
        "sml_desc": "",
        "desc": "",
        "img": "/PostCarousel/heaven.jpg",
        "side_img": "/PostCarousel/heaven.jpg",
        "read_more": "Прочитать больше",
        "link": "/Posts/index.php?post=Gourme_Heaven",
        "isVid": true,
        "forVidPage": true,
        "vidId": "n4kCnPXEX7g",
        "ctg": "telaviv",
        "id": "Gourme_Heaven"
    },


    
    {
        "title": "СОВРЕМЕННЫЙ И ДИНАМИЧНЫЙ",
        // "sml_desc": "Достопримечательности в центре Иерусалима",
        "sml_desc": "",
        "desc": "",
        "img": "/PostCarousel/19.jpg",
        "side_img": "/PostCarousel/19.jpg",
        "read_more": "Прочитать больше",
        "link": "/Posts/index.php?post=Modern_And_Vibrant",
        "isVid": true,
        "forVidPage": true,
        "vidId": "nX9LnWAjOIY",
        "ctg": "jerusalem",
        "id": "Modern_And_Vibrant"
    },
    

    //Hadar asked to hide the video in this post on 18.01.2021
    // {
    //    "title" : "Время культуры",
    //     // "sml_desc": "Non Stop Culture",
    //     "sml_desc" : "",
    //     // "desc": "Разнообразные увлекательные музеи и уникальные галереи",
    //      "desc" : "",
    //     "img": "/PostCarousel/TelAviv/culture-telaviv.jpg",
    //     "side_img": "/PostCarousel/TelAviv/culture-telaviv.jpg",
    //     "read_more": "Прочитать больше",
    //     "link": "/Posts/index.php?post=Non_Stop_Culture",
    //     "isVid": false,
    //     "forVidPage": true,
    //     "vidId":"MXtcTm_JXus",
    //     "ctg": "telaviv",
    //     "id": "Non_Stop_Culture"
    // },
    // End Hadar asked to hide the video in this post on 18.01.2021
    
    {
       "title": "РАЗВЛЕЧЕНИЯ В ПОРТУ",
        // "sml_desc": «Очарование портов Тель-Авива и Яффо»",
        "sml_desc" : "",
        // "desc": "Tel Aviv’s fascinating cultural scene",
         "desc" : "",
        "img": "/PostCarousel/3.jpg",
        "img_mob":"/PostCarousel/video_mob/3.jpg",
        "side_img": "/PostCarousel/3.jpg",
        "read_more": "Прочитать больше",
        "link": "/Posts/index.php?post=Port_Pleasures",
        "isVid": true,
        "forVidPage": true,
        "ctg": "telaviv",
        "vidId" : "FRmgXjfVPoE",
        "id": "Port_Pleasures"
    },

    {
       "title": "МЕРТВОЕ МОРЕ",
        // "sml_desc": "Вознеситесь на пик жизненной энергии в самой низкой точке планеты",
        "sml_desc" : "",
        // "desc": "Tel Aviv’s fascinating cultural scene",
         "desc" : "",
        "img": "/PostCarousel/DeadSea/natures-glory.jpg",
         "img_mob":"/PostCarousel/video_mob/natures-glory.jpg",
        "side_img": "/PostCarousel/DeadSea/natures-glory.jpg",
        "read_more": "Прочитать больше",
        "link": "/Posts/index.php?post=Dead_Sea_Video",
        "isVid": true,
        "forVidPage": true,
        "ctg": "deadsea",
        "vidId" : "ixFocykfYHo",
        "id": "Dead_Sea_Video"
    },
   

    {
        "title": "СТАРЫЙ ГОРОД ИЕРУСАЛИМА",
        // "sml_desc": "Почувствуйте, как оживает<Br/> история перед вашими глазами",
        "sml_desc": "",
        // "desc": "Проникнитесь всемирно известными ценностями<br> старого города в Иерусалиме",
        "desc": "",
        "img": "Videos/m.jpg",
        "img_mob":"/Videos/video_mob/m.jpg",
        "side_img": "Videos/sidebar/m.jpg",
        "vidId": "gGe4W8WaIiQ",
        "read_more": "Прочитать больше",
        "link": "/Posts/index.php?post=Old_City_Jerusalem",
        "ctg": "jerusalem",
        "isVid": true,
        "forVidPage": true,
        "id": "Old_City_Jerusalem"
    },
    
    
    {
        "title": "ПРЕКРАСНЫЕ ПЛЯЖИ",
        // "sml_desc": "Отдохните на солнечных пляжах Тель-Авива",
        "sml_desc": "",
        "desc": "",
        "img": "/PostCarousel/TelAviv/sensational-beaches2.jpg",
        "side_img": "/PostCarousel/TelAviv/sensational-beaches2.jpg",
        "read_more": "Прочитать больше",
        "link": "/Posts/index.php?post=Sensational_Beaches",
        "isVid": true,
        "forVidPage": true,
        "vidId":"PdTkXbiBpFs",
        "ctg": "telaviv",
        "id":"Sensational_Beaches"
    },
    {
        "title": "УВЛЕЧЕНИЯ БЕЗ ОГРАНИЧЕНИЙ",
        // "sml_desc": "Красивый, красочный и захватывающий – Удивительный Тель-Авив ",
        "sml_desc": "",
        "desc": "",
        "img": "/PostCarousel/TelAviv/nonstop-excitement2.jpg",
        "side_img": "/PostCarousel/TelAviv/nonstop-excitement2.jpg",
        "read_more": "Прочитать больше",
        "link": "/Posts/index.php?post=Nonstop_Excitement",
        "ctg": "telaviv",
        "isVid": true,
        "forVidPage": true,
        "vidId": "88OV6xU0vPI",
        "id": "Nonstop_Excitement"
    },
    
    {
        "title": "Иерусалим зовет",
        // "sml_desc": "Самый волшебный и сияющий <br>город на Земле",
        "sml_desc": "",
        "desc": "",
        "img": "/PostCarousel/Jerusalem/jerusalem-calling.jpg",
        "side_img": "/PostCarousel/Jerusalem/jerusalem-calling.jpg",
        "read_more": "Прочитать больше",
        "link": "/Posts/index.php?post=Jerusalem_Journey_In_Time",
        "isVid": true,
        "forVidPage": true,
        "vidId" : "7fT4dBioVi4",
        "ctg": "jerusalem",
        "id": "Jerusalem_Journey_In_Time"
    },



    {
        "title": "ВЕЛИЧЕСТВЕННАЯ ПУСТЫНЯ",
        // "sml_desc": "Приключения под солнцем пустыни. В пустыне Негев вам будет некогда скучать, ведь здесь столько всего интересного",
        "sml_desc": "",
        "desc": "",
        "img": "/PostCarousel/16.jpg",
        "side_img": "/PostCarousel/16.jpg",
        "read_more": "Прочитать больше",
        "link": "/Posts/index.php?post=The_Desert_Negev",
        "isVid": true,
        "forVidPage": true,
        "vidId": "yXzhH92kREg",
        "ctg": "eilat-negev",
        "id": "The_Desert_Negev"
    },

       // Eilat Posts
        
        {
         "title":"ЭЙЛАТ СТРАНА ВЕЧНОГО ЛЕТА",
         "sml_desc":"",
         "desc":"",
         "img":"/PostCarousel/welcome-to-eilat.jpg",
         "side_img":"/PostCarousel/welcome-to-eilat.jpg",
         "read_more":"READ MORE",
         "link": "/Posts/index.php?post=Welcome_To_Eilat", 
         "css_class":"unic-post-welcome-to-eilat",
         "isVid" : true,
         "forVidPage": true,
         "vidId":"ZdnNT-GDJv4",
         "ctg"   : 'eilat-negev',
          "id"    : 'Welcome_To_Eilat'
        },
       
        {
         "title":"ДЕЛЬФИНИЙ РИФ В ЭЙЛАТЕ",
         "sml_desc":"",
         "desc":"",
         "img":"/PostCarousel/eilat-doolphin-reef.jpg",
         "side_img":"/PostCarousel/eilat-doolphin-reef.jpg",
         "read_more":"READ MORE",
         "link": "/Posts/index.php?post=Eilat_Doolphin_Reef", 
         "css_class":"unic-post-eilat-doolphin-reef",
         "isVid" : true,
         "forVidPage": true,
         "vidId":"3Cvz8GoxNzA",
         "ctg"   : 'eilat-negev',
          "id"    : 'Eilat_Doolphin_Reef'
        },
       
        {
         "title":"ЗАДЕРЖАТЬ ВДОХ И НЫРНУТЬ",
         "sml_desc":"",
         "desc":"",
         "img":"/PostCarousel/eilat-ultimate-beachside.jpg",
         "side_img":"/PostCarousel/eilat-ultimate-beachside.jpg",
         "read_more":"READ MORE",
         "link": "/Posts/index.php?post=Eilat_Ultimate_Beachside", 
         "css_class":"unic-post-eilat-ultimate-beachside",
         "isVid" : true,
         "forVidPage": true,
         "vidId":"ZdnNT-GDJv4",
         "ctg"   : 'eilat-negev',
          "id"    : 'Eilat_Ultimate_Beachside'
        },
       
      
        {
         "title":"НЕГЕВ",
         "sml_desc":"",
         "desc":"",
         "img":"/PostCarousel/majestic-desert.jpg",
         "side_img":"/PostCarousel/majestic-desert.jpg",
         "read_more":"READ MORE",
         "link": "/Posts/index.php?post=Majestic_Desert", 
         "css_class":"unic-post-majestic-desert",
         "isVid" : true,
         "forVidPage": true,
         "vidId": "yXzhH92kREg",
         "ctg"   : 'eilat-negev',
          "id"    : 'Majestic_Desert'
        },
        
        {
         "title":"АКТИВНЫЙ ОТДЫХ В ИЗРАИЛЬСКОЙ ПУСТЫНЕ",
         "sml_desc":"",
         "desc":"",
         "img":"/PostCarousel/action-fun-in-the-desert.jpg",
         "side_img":"/PostCarousel/action-fun-in-the-desert.jpg",
         "read_more":"READ MORE",
         "link": "/Posts/index.php?post=Action_Fun_In_The_Desert", 
         "css_class":"unic-post-action-fun-in-the-desert",
         "isVid" : true,
         "forVidPage": true,
         "vidId":"yXzhH92kREg",
         "ctg"   : 'eilat-negev',
          "id"    : 'Action_Fun_In_The_Desert'
        },
        
        {
         "title":"ПУТЬ БЛАГОВОНИЙ",
         "sml_desc":"",
         "desc":"",
         "img":"/PostCarousel/the-incense-route.jpg",
         "side_img":"/PostCarousel/the-incense-route.jpg",
         "read_more":"READ MORE",
         "link": "/Posts/index.php?post=The_Incense_Route", 
         "css_class":"unic-post-the-incense-route",
         "isVid" : true,
         "forVidPage": true,
         "vidId":"5AAqIhkq_tQ",
         "ctg"   : 'eilat-negev',
          "id"    : 'The_Incense_Route'
        },
        
       
        {
         "title" :"МАСАДА",
         "sml_desc":"",
         "desc":"",
         "img":"/PostCarousel/epic-masada.jpg",
         "side_img":"/PostCarousel/epic-masada.jpg",
         "read_more":"READ MORE",
         "link": "/Posts/index.php?post=Epic_Masada", 
         "css_class":"unic-post-epic-masada",
         "isVid" : true,
         "forVidPage": true,
         "vidId":"XxWa_MNm5x8",
         "ctg"   : 'eilat-negev',
          "id"    : 'Epic_Masada'
        },
        
        {
         "title":"ПАРК ТИМНА",
         "sml_desc":"",
         "desc":"",
         "img":"/PostCarousel/timna-treasures.jpg",
         "side_img":"/PostCarousel/timna-treasures.jpg",
         "read_more":"READ MORE",
         "link": "/Posts/index.php?post=Timna_Treasures", 
         "css_class":"unic-post-timna-treasures",
         "isVid" : true,
         "forVidPage": true,
         "vidId":"i_4QKtXIeto",
         "ctg"   : 'eilat-negev',
          "id"    : 'Timna_Treasures'
        },
       
        
        {
         "title":"КЕСАРИЯ",
         "sml_desc":"",
         "desc":"",
         "img":"/PostCarousel/caesarea.jpg",
         "side_img":"/PostCarousel/caesarea.jpg",
         "read_more":"READ MORE",
         "link": "/Posts/index.php?post=Caesarea", 
         "css_class":"unic-post-caesarea",
         "isVid" : true,
         "forVidPage": true,
         "vidId":"eLZ433_S6HI",
         "ctg"   : 'north',
          "id"    : 'Caesarea'
        },
        {
         "title":"СТАРЫЙ АККО ",
         "sml_desc":"",
         "desc":"",
         "img":"/PostCarousel/acre.jpg",
         "side_img":"/PostCarousel/acre.jpg",
         "read_more":"READ MORE",
         "link": "/Posts/index.php?post=Acre", 
         "css_class":"unic-post-acre",
         "isVid" : true,
         "forVidPage": true,
         "vidId":"KlXXyToCmCM",
         "ctg"   : 'north',
          "id"    : 'Acre'
       },
        {
         "title":"ХАЙФА",
         "sml_desc":"",
         "desc":"",
         "img":"/PostCarousel/haifa.jpg",
         "side_img":"/PostCarousel/haifa.jpg",
         "read_more":"READ MORE",
         "link": "/Posts/index.php?post=Haifa", 
         "css_class":"unic-post-haifa",
         "isVid" : true,
         "forVidPage": true,
         "vidId":"3ahATaKkhBk",
         "ctg"   : 'north',
          "id"    : 'Haifa'
        },
        {
         "title":"ЦФАТ",
         "sml_desc":"",
         "desc":"",
         "img":"/PostCarousel/safed.jpg",
         "side_img":"/PostCarousel/safed.jpg",
         "read_more":"READ MORE",
         "link": "/Posts/index.php?post=Safed", 
         "css_class":"unic-post-safed",
         "isVid" : true,
         "forVidPage": true,
         "vidId":"i3_ihL51bHo",
         "ctg"   : 'north',
          "id"    : 'Safed'
        },
        
        {
         "title":"КИННЕРЕТ",
         "sml_desc":"",
         "desc":"",
         "img":"/PostCarousel/sea-of-galilee.jpg",
         "side_img":"/PostCarousel/sea-of-galilee.jpg",
         "read_more":"READ MORE",
         "link": "/Posts/index.php?post=The_Sea_Of_Galilee", 
         "css_class":"unic-post-sea-of-galilee",
         "isVid" : true,
         "forVidPage": true,
         "vidId":"haG-t3wwuMc",
         "ctg"   : 'north',
          "id"    : 'The_Sea_Of_Galilee'
        },
        {
         "title":"РОШ-ПИННА",
         "sml_desc":"",
         "desc":"",
         "img":"/PostCarousel/rosh-pina.jpg",
         "side_img":"/PostCarousel/rosh-pina.jpg",
         "read_more":"READ MORE",
         "link": "/Posts/index.php?post=Rosh_Pina", 
         "css_class":"unic-post-rosh-pina",
         "isVid" : true,
         "forVidPage": true,
         "vidId":"_qKbHL5-qrQ",
         "ctg"   : 'north',
          "id"    : 'Rosh_Pina'
        },
        {
            "title": "ПРЕЛЕСТИ МЁРТВОГО МОРЯ",
            // "sml_desc": "Для бесконечно приятного времяпрепровождения",
            "sml_desc": "",
            "desc": "",
            "img": "/PostCarousel/DeadSea/deadsea2.jpg",
             "img_mob":"/PostCarousel/video_mob/100.jpg",
            "side_img": "/PostCarousel/DeadSea/deadsea2.jpg",
            "read_more": "Прочитать больше",
            "link": "/Posts/index.php?post=Dead_Sea2",
            "isVid": true,
            "forVidPage": true,
            "isDouble": true,
            "vidId": "9aDP-jV6soE",
            "ctg": "deadsea",
            "id": "Dead_Sea2"
        },
        {
         "title":"НАЗАРЕТ КОЛЫБЕЛЬ ХРИСТИАНСТВА",
         "sml_desc":"",
         "desc":"",
         "img":"/PostCarousel/nazareth.jpg",
         "side_img":"/PostCarousel/nazareth.jpg",
         "read_more":"READ MORE",
         "link": "/Posts/index.php?post=Nazareth_Christian_Cradle", 
         "css_class":"unic-post-nazareth",
         "isVid" : true,
         "forVidPage": true,
         "vidId":"1M7N5BcmjFM",
         "ctg"   : 'north',
          "id"    : 'Nazareth_Christian_Cradle'
        },

       
        
        {
         "title":"ГАЛИЛЕЯ ПРЯМО ПО КУРСУ",
         "sml_desc":"",
         "desc":"",
         "img":"/PostCarousel/galilee-action.jpg",
         "side_img":"/PostCarousel/galilee-action.jpg",
         "read_more":"READ MORE",
         "link": "/Posts/index.php?post=Galilee_Action", 
         "css_class":"unic-post-galilee-action",
         "isVid" : true,
         "forVidPage": true,
         "vidId":"5Ep3GgxELag",
         "ctg"   : 'north',
          "id"    : 'Galilee_Action'
        },
        {
         "title":"НАЗАРЕТ",
         "sml_desc":"",
         "desc":"",
         "img":"/PostCarousel/nazareth2.jpg",
         "side_img":"/PostCarousel/nazareth2.jpg",
         "read_more":"READ MORE",
         "link": "/Posts/index.php?post=Nazareth", 
         "css_class":"unic-post-nazareth2",
         "isVid" : true,
         "forVidPage": true,
         "vidId":"1M7N5BcmjFM",
         "ctg"   : 'north',
          "id"    : 'Nazareth'
        },
        
        
        {
         "title":"ОЗЕРО ХУЛА",
         "sml_desc":"",
         "desc":"",
         "img":"/PostCarousel/birdtastic-hula-lake.jpg",
         "side_img":"/PostCarousel/birdtastic-hula-lake.jpg",
         "read_more":"READ MORE",
         "link": "/Posts/index.php?post=Birdtastic_Hula_Lake", 
         "css_class":"unic-post-birdtastic-hula-lake",
         "isVid" : true,
         "forVidPage": true,
         "vidId":"ImobrsxsKl8",
         "ctg"   : 'north',
          "id"    : 'Birdtastic_Hula_Lake'
        },

        


]



// start showsArr

// export const showsArr = [
      
      
     
      

      
//       {
//         title: "Nick Cave & Bad Seeds",
//         desc: "",
//         date: "17.06.20",
//         img: "Concerts/nickcave-badseeds.jpg",
//         side_img: "Concerts/nickcave-badseeds.jpg",
//         link: this.url + "/Posts/index.php?postType=concerts&post=Nickcave-Badseeds",
//         id: "Nickcave_Badseeds",
//         css_class: "unic-singer-nickcave-badseeds",
//         book_now : "Прочитать больше"
//       },
//       {
//         title: "The Pixies",
//         desc: "",
//         date: "09.2020",
//         img: "Concerts/1.jpg",
//         side_img: "Concerts/1.jpg",
//         link: this.url + "/Posts/index.php?postType=concerts&post=The_Pixies_2020",
//         css_class: "unic-singer-pixies-2020",
//         id: "The_Pixies_2020",
//         book_now : "Прочитать больше"
//       },
//       {
//         title: "Селин Дион",
//         desc: "",
//         date: "04.08.20",
//         img: "Concerts/Celine_Dion.jpg",
//         side_img: "Concerts/Celine_Dion.jpg",
//         link: this.url + "/Posts/index.php?postType=concerts&post=Celine_Dion",
//         css_class: "unic-singer-Celine_Dion",
//         id: "Celine_Dion",
//         book_now : "Прочитать больше"
//       },
//       {
//         title: "Фестиваль DGTL",
//         desc: "",
//         date: "08.2020",
//         img: "Concerts/dgtl-festival.jpg",
//         side_img: "Concerts/dgtl-festival.jpg",
//         link: this.url + "/Posts/index.php?postType=concerts&post=DGTL_Festival",
//         css_class: "unic-singer-dgtl2020",
//         id: "DGTL_Festival_2020",
//         book_now : "Прочитать больше"
//       },

//       {
//         title: "Хуцот Ха-Йоцер в Иерусалиме",
//         desc: "",
//         date: "08.2020",
//         img: "Concerts/international-arts.jpg",
//         side_img: "Concerts/international-arts.jpg",
//         link: this.url + "/Posts/index.php?postType=concerts&post=Hutzot_Hayotzer_Jerusalem_2020",
//         css_class: "unic-singer-hutzot_hayotzer",
//         id: "Hutzot_Hayotzer_Jerusalem_2020", 
//         book_now : "Прочитать больше"
//       },

//       {
//         title: "Иерусалимский фестиваль пива",
//         desc: "",
//         date: "08.2020",
//         img: "Concerts/jer-beer-ferstival.jpg",
//         side_img: "Concerts/jer-beer-ferstival.jpg",
//         link: this.url + "/Posts/index.php?postType=concerts&post=Jerusalem_Beer_Festival_2020",
//         css_class: "unic-singer-jbf_2020",
//         id: "Jerusalem_Beer_Festival_2020",
//         book_now : "Прочитать больше"
//       },

//       {
//         title: "Иерусалимский фестиваль вина",
//         desc: "",
//         date: "08.2020",
//         img:"Concerts/wineFestive.jpg",
//         side_img:"Concerts/wineFestive.jpg",
//         link: "/Posts/index.php?postType=concerts&post=Jerusalem Wine Festival_2020",
//         css_class: "unic-singer-jwf-2020",
//         id: "Jerusalem_Wine_Festival_2020",
//         book_now : "Прочитать больше"
//       },

//       {
//         title: "Фестиваль \"Открытые дома\"",
//         desc: "",
//         date: "09.2020",
//         img: "Concerts/open-houses-festival.jpg",
//         side_img: "Concerts/open-houses-festival.jpg",
//         link: this.url + "/Posts/index.php?postType=concerts&post=Open_Houses_Festival_2020",
//         css_class: "unic-singer-openhf-2020",
//         id: "Open_Houses_Festival_2020",
//         book_now : "Прочитать больше"
//       },
//       {
//         title: "Иерусалимский марш",
//         desc: "",
//         date: "03.09.2020",
//         img: "Concerts/jerusalem-march.jpg",
//         side_img: "Concerts/jerusalem-march.jpg",
//         link: this.url + "/Posts/index.php?postType=concerts&post=Open_Houses_Festival_2020",
//         css_class: "unic-singer-jerusalem-march-2020",
//         id: "The_Jerusalem_March_2020",
//         book_now : "Прочитать больше"
//       },
//       {
//         title: "Селин Дион",
//         desc: "",
//         date: "04.08.20",
//         img: "Concerts/Celine_Dion.jpg",
//         side_img: "Concerts/Celine_Dion.jpg",
//         link: this.url + "/Posts/index.php?postType=concerts&post=Celine_Dion",
//         css_class: "unic-singer-Celine_Dion",
//         id: "Celine_Dion",
//         isDouble: true,
//         book_now : "Прочитать больше"
//       },
//       {
//         title: "Иерусалимский фестиваль пива",
//         desc: "",
//         date: "08.2020",
//         img: "Concerts/jer-beer-ferstival.jpg",
//         side_img: "Concerts/jer-beer-ferstival.jpg",
//         link: this.url + "/Posts/index.php?postType=concerts&post=Jerusalem_Beer_Festival_2020",
//         css_class: "unic-singer-jbf_2020",
//         id: "Jerusalem_Beer_Festival_2020",
//         isDouble: true,
//         book_now : "Прочитать больше"
//       },
//       {
//         title: "Иерусалимский фестиваль вина",
//         desc: "",
//         date: "08.2020",
//         img:"Concerts/wineFestive.jpg",
//         side_img:"Concerts/wineFestive.jpg",
//         link: "/Posts/index.php?postType=concerts&post=Jerusalem Wine Festival_2020",
//         css_class: "unic-singer-jwf-2020",
//         id: "Jerusalem_Wine_Festival_2020",
//         isDouble: true,
//         book_now : "Прочитать больше"
//       },
      

      

      

      
       
      

      

//       /*----------------OLD SINGERS------------------*/

//       {
//         title: "Natalia Oreiro",
//         desc: "Natalia to Wow Tel Aviv in March",
//         date: "20.03.2018",
//         img: "Concerts/32.jpg",
//         side_img: "Concerts/Sidebar/46.jpg",
//         link:  "/Posts/index.php?postType=concerts&post=44",
//         css_class: "unic-singer-13",
//         id:44,
//         book_now: "Прочитать больше"
//       },


//        {
//         title: "Backstreet Boys",
//         desc: "The Backstreet Boys are Back and Larger Than Life",
//         date: "22.04.2018",
//         img: "Concerts/51.jpg",
//         side_img: "Concerts/Sidebar/53.jpg",
//         link:  "/Posts/index.php?postType=concerts&post=51",
//         css_class: "unic-singer-20",
//         id:51,
//         a_star: true,
//         book_now: "Прочитать больше"
//       },
      
//       {
//        title: "Led Zeppelin 2",
//        desc : "Don’t Miss the Zeps in Tel Aviv!" ,
//        date : "07-10.01.2018",
//        img  : "Concerts/20.jpg",
//        side_img  : "Concerts/Sidebar/29.jpg" ,
//        link :  "/Posts/index.php?postType=concerts&post=29" ,
//        css_class: "unic-singer-3",
//        id:29,
//        book_now : "Прочитать больше"
//       },

//       {
//         title: "Chris Rock",
//         desc: "PULL OUT THE SUNSCREEN! FREE TO BE YOURSELF ON THE BEACH",
//         date: "08-09.01.2018",
//         img: "Concerts/6.jpg",
//         side_img: "Concerts/Sidebar/16.jpg",
//         link:  "/Posts/index.php?postType=concerts&post=17",
//         css_class: "unic-singer-4",
//         id:17,
//         book_now: "Прочитать больше"
//       },

//       {
//        title: "Jerry Seinfeld",
//        desc : "Live in Tel Aviv for the first time ever!" ,
//        date : "30.12.2017",
//        img  : "Concerts/jerry.jpg",
//        side_img  : "Concerts/Sidebar/jerry.jpg" ,
//        link :  "/Posts/index.php?postType=concerts&post=36" ,
//        css_class: "unic-singer-2",
//        id:36,
//        book_now : "Прочитать больше"
//       },

//       {
//        title: "Buena Vista",
//        desc : "Live in Tel Aviv for the first time ever!" ,
//        date : "21-26.12.2017",
//        img  : "Concerts/buena.jpg",
//        side_img  : "Concerts/Sidebar/buena.jpg" ,
//        link :  "/Posts/index.php?postType=concerts&post=35" ,
//        id:35,
//        book_now : "Прочитать больше"
//       },

//      {
//        title: "Justin Bieber",
//        desc : "PULL OUT THE SUNSCREEN! FREE TO BE YOURSELF ON THE BEACH" ,
//        date : "03.05.2017",
//        img  : "Concerts/justin.jpg",
//        side_img  : "Concerts/Sidebar/9.jpg" ,
//        link :  "/Posts/index.php?postType=concerts&post=9" ,
//        a_star  : true,
//        id:9,
//        book_now : "Прочитать больше"
//       },

//       {
//        title: "AEROSMITH",
//        desc : "PULL OUT THE SUNSCREEN! FREE TO BE YOURSELF ON THE BEACH" ,
//        date : "28.06.2017",
//        img  : "Concerts/aerosmith3.jpg",
//        side_img  : "Concerts/Sidebar/10.jpg" ,
//        link :  "/Posts/index.php?postType=concerts&post=10" ,
//        a_star  : true,
//        id:10,
//        book_now : "Прочитать больше"
//       },

//       {
//        title: "Britney Spears ",
//        desc : "PULL OUT THE SUNSCREEN! FREE TO BE YOURSELF ON THE BEACH" ,
//        date : "03.07.2017",
//        img  : "Concerts/britney.jpg",
//        side_img  : "Concerts/Sidebar/2.jpg" ,
//        link :  "/Posts/index.php?postType=concerts&post=2" ,
//        a_star  : true,
//        id: 2,
//        book_now : "Прочитать больше"
//       },

//       {
//        title: "Guns N' Roses",
//        desc : "PULL OUT THE SUNSCREEN! FREE TO BE YOURSELF ON THE BEACH" ,
//        date : "15.07.2017",
//        img  : "Concerts/Guns-N-roses.jpg",
//        side_img  : "Concerts/Sidebar/4.jpg" ,
//        link :  "/Posts/index.php?postType=concerts&post=4" ,
//        a_star  : true,
//        id:4,
//        book_now : "Прочитать больше"
//       },

//       {
//        title: "Bryan Adams ",
//        desc : "PULL OUT THE SUNSCREEN! FREE TO BE YOURSELF ON THE BEACH" ,
//        date : "04-06.12.2017",
//        img  : "Concerts/7.jpg",
//        side_img  : "Concerts/Sidebar/15.jpg" ,
//        link :  "/Posts/index.php?postType=concerts&post=16" ,
//        a_star  : true,
//        id:16,
//        book_now : "Прочитать больше"
//       },

//       {
//        title: "NICK CAVE ",
//        desc : "PULL OUT THE SUNSCREEN! FREE TO BE YOURSELF ON THE BEACH" ,
//        date : "19.11.2017",
//        img  : "Concerts/4.jpg",
//        side_img  : "Concerts/Sidebar/8.jpg" ,
//        link :  "/Posts/index.php?postType=concerts&post=8" ,
//        id:8,
//        book_now : "Прочитать больше"
//       },

//       {
//         title: "RADIOHEAD ",
//         desc : "PULL OUT THE SUNSCREEN! FREE TO BE YOURSELF ON THE BEACH" ,
//         date : "19.07.2017",
//         img  : "Concerts/360x539.jpg",
//         side_img  : "Concerts/Sidebar/5.jpg" ,
//         link :  "/Posts/index.php?postType=concerts&post=5" ,
//         a_star  : true,
//         id:5,
//         book_now : "Прочитать больше"
//       },

//       {
//        title: "The Chainsmokers",
//        desc : "PULL OUT THE SUNSCREEN! FREE TO BE YOURSELF ON THE BEACH" ,
//        date : "3.08.2017",
//        img  : "Concerts/9.jpg",
//        side_img  : "Concerts/Sidebar/14.jpg" ,
//        link :  "/Posts/index.php?postType=concerts&post=13" ,
//        id:13,
//        book_now : "Прочитать больше"
//       },

//       {
//        title: "Blue Man Group",
//        desc : "PULL OUT THE SUNSCREEN! FREE TO BE YOURSELF ON THE BEACH" ,
//        date : "7-23.08.2017",
//        img  : "Concerts/14.jpg",
//        side_img  : "Concerts/Sidebar/22.jpg" ,
//        link :  "/Posts/index.php?postType=concerts&post=19" ,
//        id:19,
//        book_now : "Прочитать больше"
//       },

//       {
//        title: "Regina Spektor",
//        desc : "PULL OUT THE SUNSCREEN! FREE TO BE YOURSELF ON THE BEACH" ,
//        date : "19.08.2017",
//        img  : "Concerts/2.jpg",
//        side_img  : "Concerts/Sidebar/7.jpg" ,
//        link :  "/Posts/index.php?postType=concerts&post=7" ,
//        id:7,
//        book_now : "Прочитать больше"
//       },

//       {
//        title: "Sean Paul",
//        desc : "PULL OUT THE SUNSCREEN! FREE TO BE YOURSELF ON THE BEACH" ,
//        date : "22.08.2017",
//        img  : "Concerts/13.jpg",
//        side_img  : "Concerts/Sidebar/21.jpg" ,
//        link :  "/Posts/index.php?postType=concerts&post=20" ,
//       id:20,
//        a_star  : true,
//        book_now : "Прочитать больше"
//       },

//       {
//         title: "Pride Parade 2019",
//         desc: "",
//         date: "14.06.2019",
//         img:"Concerts/Pride_Parade_2019.jpg",
//         side_img:"Concerts/Pride_Parade_2019.jpg",
//         link:"/Posts/index.php?postType=concerts&post=Pride_Parade_2019",
//         css_class: "unic-singer-Pride_Parade_2019",
//         id: "Pride_Parade_2019",
//         book_now : "Прочитать больше"
//       },

//       {
//         title: "Daddy Yankee",
//         desc: "",
//         date: "26.06.2019",
//         img: "Concerts/daddyyanke.jpg",
//         side_img: "Concerts/bon-j.jpg",
//         link: "/Posts/index.php?postType=concerts&post=76",
//         css_class: "unic-singer-daddyyanke",
//         book_now : "Прочитать больше"
//       },

//       {
//         title: "Tom Jones",
//         desc: "",
//         date: "03.07.2019",
//         img: "Concerts/tomjones.jpg",
//         side_img: "Concerts/bon-j.jpg",
//         link: "/Posts/index.php?postType=concerts&post=76",
//         css_class: "unic-singer-tomjones",
//         book_now : "Прочитать больше"
//       },

//       {
//         title: "Paul Anka",
//         desc: "",
//         date: "11.07.2019",
//         img: "Concerts/paul.jpg",
//         side_img: "Concerts/bon-j.jpg",
//         link: "/Posts/index.php?postType=concerts&post=76",
//         css_class: "unic-singer-paul",
//         book_now : "Прочитать больше"
//       },

//       {
//         title: "Sean Paul",
//         desc: "",
//         date: "13.07.2019",
//         img: "Concerts/seanpaul.jpg",
//         side_img: "Concerts/bon-j.jpg",
//         link: "/Posts/index.php?postType=concerts&post=76",
//         css_class: "unic-singer-seanpaul",
//         book_now : "Прочитать больше"
//       },

//       {
//         title: "Ozuna",
//         desc: "",
//         date: "24.07.2019",
//         img: "Concerts/ozuna.jpg",
//         side_img: "Concerts/bon-j.jpg",
//         link: "/Posts/index.php?postType=concerts&post=76",
//         css_class: "unic-singer-ozuna",
//         book_now : "Прочитать больше"
//       },

//       {
//         title: "Jerusalem Film Festival",
//         desc: "36 Years of Cinema Magic!",
//         date: "04.08.2019",
//         img:"Concerts/filmFestive.jpg",
//         side_img:"Concerts/filmFestive.jpg",
//         link: "/Posts/index.php?postType=concerts&post=68",
//         css_class: "unic-singer-68",
//         id:68,
//         book_now : "Прочитать больше"
//       },

//       {
//         title: "Bon Jovi",
//         desc: "Bon Jovi are Back to take over the hot hot hot Tel Aviv Summer!",
//         date: "25.07.2019",
//         img: "Concerts/bon-j.jpg",
//         side_img: "Concerts/bon-j.jpg",
//         link: "/Posts/index.php?postType=concerts&post=76",
//         css_class: "unic-singer-76",
//         id: 76,
//         book_now : "Прочитать больше"
//       },

//       {
//         title: "J Balvin",
//         desc: "",
//         date: "30.07.2019",
//         img: "Concerts/balvin.jpg",
//         side_img: "Concerts/bon-j.jpg",
//         link: "/Posts/index.php?postType=concerts&post=76",
//         css_class: "unic-singer-balvin",
//         book_now : "Прочитать больше"
//       },

//       {
//         title: "Jerusalem Wine Festival",
//         desc: "Wine and dine in the holy city!",
//         date: "30.07.2019",
//         img:"Concerts/wineFestive.jpg",
//         side_img:"Concerts/wineFestive.jpg",
//         link: "/Posts/index.php?postType=concerts&post=69",
//         css_class: "unic-singer-69",
//         id:69,
//         book_now : "Прочитать больше"
//       },

//       {
//         title: "J.Lo",
//         desc: "",
//         date: "01.08.2019",
//         img:"Concerts/jlo.jpg",
//         side_img:"Concerts/jlo.jpg",
//         link:"/Posts/index.php?postType=concerts&post=jlo",
//         css_class: "unic-singer-jlo",
//         id: "J_Lo",
//         book_now : "Прочитать больше"
//       },

//       {
//         title: "The International Arts",
//         desc: "",
//         date: "12-24.08.2019",
//         img: "Concerts/international-arts.jpg",
//         side_img: "Concerts/international-arts.jpg",
//         link: this.url + "/Posts/index.php?postType=concerts&post=94",
//         css_class: "unic-singer-inter-arts",
//         id: "The_International_Arts", 
//         book_now : "Прочитать больше"
//       },

//       {
//         title: "Jerusalem Beer Festival",
//         desc: "",
//         date: "28-29.08.2019",
//         img: "Concerts/jer-beer-ferstival.jpg",
//         side_img: "Concerts/jer-beer-ferstival.jpg",
//         link: this.url + "/Posts/index.php?postType=concerts&post=91",
//         css_class: "unic-singer-jbf",
//         id: "Jerusalem_Beer_Festival",
//         book_now : "Прочитать больше"
//       },

//       {
//         title: "Lionel Richie",
//         desc: "",
//         date: "12.09.2019",
//         img:"Concerts/lionel-richie.jpg",
//         side_img:"Concerts/lionel-richie.jpg",
//         link:"/Posts/index.php?postType=concerts&post=lionelrichie",
//         css_class: "unic-singer-lionel-richie",
//         book_now : "Прочитать больше"
//       },

//       {
//         title: "Open Houses Festival",
//         desc: "",
//         date: "19-21.09.2019",
//         img: "Concerts/open-houses-festival.jpg",
//         side_img: "Concerts/open-houses-festival.jpg",
//         link: this.url + "/Posts/index.php?postType=concerts&post=96",
//         css_class: "unic-singer-openhf",
//         id: "Open_Houses_Festival",
//         book_now : "Прочитать больше"
//       },

      

//       {
//         title: "Open Restaurants TLV",
//         desc: " Feed Your Curiosity!",
//         date: "2019",
//         img: "Concerts/71.jpg",
//         side_img: "Concerts/72.jpg",
//         link: this.url + "/Posts/index.php?postType=concerts&post=70",
//         css_class: "unic-singer-70",
//         book_now : "Прочитать больше"
//       },
//        {
//         title: "DGTL FESTIVAL",
//         desc: "",
//         date: "14.10.2019",
//         img: "Concerts/dgtl-festival.jpg",
//         side_img: "Concerts/dgtl-festival.jpg",
//         link: this.url + "/Posts/index.php?postType=concerts&post=93",
//         css_class: "unic-singer-dgtl2019",
//         id: "DGTL_Festival",
//         book_now : "Прочитать больше"
//       },
//       {
//         title: "Cycle Tel Aviv",
//         desc: "",
//         date: "18.10.2019",
//         img: "Concerts/cycle-tlv-2019.jpg",
//         side_img: "Concerts/cycle-tlv-2019.jpg",
//         link: this.url + "/Posts/index.php?postType=concerts&post=93",
//         css_class: "unic-singer-cycle-tlv-2019",
//         id: "Cycle_Tel_Aviv",
//         book_now : "Прочитать больше"
//       },
//       {
//         title: "Night Run Tel Aviv",
//         desc: "",
//         date: "30.10.2019",
//         img: "Concerts/night-run-tlv.jpg",
//         side_img: "Concerts/night-run-tlv.jpg",
//         link: this.url + "/Posts/index.php?postType=concerts&post=98",
//         css_class: "unic-singer-tlv-nightrun2019",
//         id: "Night_Run_TelAviv",
//         book_now : "Прочитать больше"
//       },

//       {
//         title: "Culinary Festival",
//         desc: "Special Edition: Female Chefs",
//         date: "09-23.11.2019",
//         img: "Concerts/72.jpg",
//         side_img: "Concerts/73.jpg",
//         link: this.url + "/Posts/index.php?postType=concerts&post=71",
//         css_class: "unic-singer-71",
//         book_now : "Прочитать больше"
//       },
      
//      {
//         title: "Open Restaurants Jerusalem",
//         desc: "",
//         date: "19-23.11.2019",
//         img:"Concerts/Open_Restaurants_Jerusalem.jpg",
//         side_img:"Concerts/Open_Restaurants_Jerusalem.jpg",
//         link:"/Posts/index.php?postType=concerts&post=Open_Restaurants_Jerusalem",
//         css_class: "unic-singer-Open_Restaurants_Jerusalem",
//         id: "Open_Restaurants_Jerusalem",
//         book_now : "Прочитать больше"
//       },
//       {
//         title: "Louis CK",
//         desc: "",
//         date: "23.11.2019",
//         img: "Concerts/Louis_CK.jpg",
//         side_img: "Concerts/Louis_CK.jpg",
//         link: this.url + "/Posts/index.php?postType=concerts&post=Louis_CK",
//         css_class: "unic-singer-Louis_CK",
//         id: "Louis_CK",
//         book_now : "Прочитать больше"
//       },
//       {
//         title: "Jim Jeffries",
//         desc: "",
//         date: "21.12.2019",
//         img:"Concerts/jim-jeffries.jpg",
//         side_img:"Concerts/jim-jeffries.jpg",
//         link:"/Posts/index.php?postType=concerts&post=jimjeffries",
//         css_class: "unic-singer-jim-jeffries",
//         book_now : "Прочитать больше"
//       },

//       {
//         title: "Open Restaurants TLV",
//         desc: " Feed Your Curiosity!",
//         date: "2019",
//         img:"Concerts/openRestTlv.jpg",
//         side_img:"Concerts/openRestTlv.jpg",
//         link: "/Posts/index.php?postType=concerts&post=70",
//         css_class: "unic-singer-70",
//         id:70,
//         book_now : "Прочитать больше"
//       },
//       {
//         title: "Тель-Авивский Марафон",
//         desc: "",
//         date: "28.02.20",
//         img: "Concerts/tlv-marathon.jpg",
//         side_img: "Concerts/tlv-marathon.jpg",
//         link: this.url + "/Posts/index.php?postType=concerts&post=97",
//         css_class: "unic-singer-tlv-marathon2020",
//         id: "TelAviv_Marathon",
//         book_now : "Прочитать больше"
//       },
//       {
//         title: "Пурим 2020",
//         desc: "",
//         date: "09-10.03.20",
//         img: "Concerts/purim2019.jpg",
//         side_img: "Concerts/purim2019.jpg",
//         link: this.url + "/Posts/index.php?postType=concerts&post=Purim_2020",
//         css_class: "unic-purim2020",
//         id: "Purim_2020",
//         book_now : "Прочитать больше"
//       },

//       {
//         title: "Тель-авивская неделя моды",
//         desc: "",
//         date: "03.2020",
//         img: "Concerts/fationWeek.jpg",
//         side_img: "Concerts/fationWeek.jpg",
//         link: this.url + "/Posts/index.php?postType=concerts&post=TelAviv_Fashion_Week_2020",
//         css_class: "unic-fashion-week-2020",
//         id: "TelAviv_Fashion_Week_2020",
//         book_now : "Прочитать больше"
//       },
//       {
//         title: "Иерусалимский Марафон",
//         desc: "",
//         date: "20.03.20",
//         img: "Concerts/jer-marathon.jpg",
//         side_img: "Concerts/jer-marathon.jpg",
//         link: this.url + "/Posts/index.php?postType=concerts&post=95",
//         css_class: "unic-singer-jer-marathon2019",
//         id: "Jerusalem_Marathon",
//         book_now : "Прочитать больше"
//       },
//       // {
//       //   title: "The Rubinstein International Competition ",
//       //   desc: "",
//       //   date: "05-21.05.2020",
//       //   img:"Concerts/piano-competition-2020.jpg",
//       //   side_img:"Concerts/piano-competition-2020.jpg",
//       //   link:"/Posts/index.php?postType=concerts&post=Piano_Competition_2020",
//       //   css_class: "unic-singer-piano-competition-2020",
//       //   id: "Piano_Competition_2020",
//       //   book_now : "Прочитать больше"
//       // },
//       // {
//       //   title: "Red Hot Chili Peppers",
//       //   desc: "",
//       //   date: "10.06.20",
//       //   img:"Concerts/red-hot-chili-peppers-2020.jpg",
//       //   side_img:"Concerts/red-hot-chili-peppers-2020.jpg",
//       //   link:"/Posts/index.php?postType=concerts&post=Red_Hot_Chili_Peppers_2020",
//       //   css_class: "unic-singer-red-hot-chili-peppers-2020",
//       //   id: "Red_Hot_Chili_Peppers_2020",
//       //   book_now : "Прочитать больше"
//       // },
    
//       // {
//       //   title: "Белая ночь",
//       //   desc: "",
//       //   date: "06.2020",
//       //   img:"Concerts/53.jpg",
//       //   side_img:"Concerts/53.jpg",
//       //   link:"/Posts/index.php?postType=concerts&post=White_Night_2020",
//       //   css_class: "unic-singer-white-night-2020",
//       //   id: "White_Night_2020",
//       //   book_now : "Прочитать больше"
//       // },

// ];

// End showsArr

export const showsArr = [];


export const faqData  = [ 
   {  
      id : 1 ,
      q : "Часто задаваемые вопросы о COVID-19 ",
      answer : `
      <ol start="1">
                                <li><strong>Я турист и нахожусь в Израиле. Меня беспокоит, что у меня может быть COVID-19, куда я могу обратиться?</strong>
                                 <br/>
                                <ul>
                                       <li>
                                          Если вы страдаете от озноба и температуры не менее 100,4 F (38C), кашля, проблем с дыханием или других респираторных симптомов, вы должны немедленно начать самоизоляцию и позвонить на горячую линию экстренной службы 101 MDA для получения медицинской консультации. 
                                        <strong>
                                          Не обращайтесь напрямую в местную поликлинику или отделение неотложной помощи.
                                        </strong>
                                       </li>
                                   </ul>
                                </li>
                                <li><strong> Когда Израиль снова будет открыт для гостей и туристов?</strong><br/>
                                <ul>
                                       <li>
                                        На данный момент нет точной информации о том, когда Израиль будет открыт для гостей и туристов.
                                       </li>
                                   </ul>
                                </li>
                               
                               
                              </ol>
      `,
      isOpen : false
   },
   {  
      id : 2 ,
      q : "Далеко ли находится Израиль?",
      answer : `
      <p>
      Полет из Москвы до Тель-Авива занимает всего три с половиной часа, а до Эйлата — четыре с половиной часа. Из Санкт Петербурга — четыре или пять с половиной часов соответственно. Регулярные рейсы в Израиль выполняют авиакомпании Аэрофлот, El Al, Уральские авиалинии. Отправиться в Израиль можно и из таких городов России, как Новосибирск, Екатеринбург, Краснодар, Ростов-на-Дону, Минеральные Воды, Сочи.
      </p>
      `,
      isOpen : false
   },

   {  
      id : 3 ,
      q : "Какие документы понадобятся мне для поездки в Израиль?",
      answer : `
      
     <p> Гражданам России виза для въезда в Израиль не нужна. Для въезда в Израиль паспорт должен быть действителен в течение 6 месяцев с даты въезда в страну. При путешествии с ребенком он должен быть вписан в заграничный паспорт родителя, с которым путешествует (или иметь собственный загранпаспорт).
      </p>
       .
      `,
      isOpen : false,
   },
   

   {  
      id : 4 ,
      q : "Безопасно ли путешествовать по Израилю?",
      answer : `
      <p>
       Мы не приглашали бы вас, если бы это было не так. Каждый год Израиль посещает от 3 до 4 миллионов туристов, и они все возвращаются домой живыми и здоровыми — разве что кроме тех, кто полюбил израильтянина или израильтянку… или же сам Израиль! Самолеты более 90 компаний не летали бы в Израиль, если бы это было опасно.
      </p>
      `,
      isOpen : false,
   },
   

   {  
      id : 5 ,
      q : "Говорят, что перед поездкой в Израиль необходимо пройти собеседование со службой безопасности.",
      answer : `

       <p> Если вы летите израильской авиакомпанией «Эль Аль» (или из Европы авиакомпаниями «Аркиа» или «ИсраЭйр»), пожалуйста, помните, что меры безопасности, принятые на израильских авиалиниях, давно признаны эталонными и вызывают зависть всех авиакомпаний мира. При регистрации вашего полета сотрудники службы безопасности зададут вам ряд вопросов. Некоторые из них могут показаться некорректными, назойливыми, не имеющими отношения к делу или повторяющимися. Просто отвечайте правдиво, сотрудничайте с интервьюером и не теряйте самообладания. Помните, что вопросы специально составлены таким образом, чтобы защитить вас и других пассажиров. При вылете из страны самолетом любой авиалинии вас ждет аналогичная процедура.
       </p>
      `,
      isOpen : false,
   },
   

   {  
      id : 6 ,
      q : "Могу ли я соединить поездку в Израиль с поездкой в Иорданию и (или) в Египет? ",
      answer : `
       
        <p>
          Конечно. Между Тель-Авивом и Каиром и Тель-Авивом и Амманом существуют регулярные авиарейсы. Можно воспользоваться и наземным способом передвижения, и пересечь границу с Египтом в Эйлате/Таба, а границу с Иорданией — в Эйлате или через КПП «Мост Шейха Хусейна», расположенный немного южнее Галилейского моря. Для получения визы вы должны обратиться в местное египетское или иорданское консульство.
        </p>
      `,
      isOpen : false,
   },

   {  
      id :7 ,
      q : "Что делать, если я хочу посетить другое арабское государство?",
      answer : `
        
        <p>
          Пожалуйста. Как и многие европейские страны, Израиль больше не проставляет штампы в паспортах гостей страны, поэтому факт посещения Израиля не будет отражен в вашем паспорте.
        </p>
      `,
      isOpen : false,
   },
   
]



export const newPosts = [

    {
        "title": "Рынок Махане-Иегуда",
        // "sml_desc": "Праздник для всех<br> органов чувств",
        "sml_desc": "",
        // "desc": "Прочувствуйте всю прелесть этого рынка - картинки, звуки, запахи и, разумеется, вкусы",
        "desc": "",
        "img": "Videos/market-madness.jpg",
        "img_mob":"/Videos/video_mob/market-madness.jpg",
        "side_img": "Videos/sidebar/market-madness.jpg",
        "read_more": "Прочитать больше",
        "link": "/Posts/index.php?post=Market_Madness",
        "vidId": "2CSCe2WC7Ns",
        "ctg": "culinaryjerusalem",
        "isVid": true,
        "forVidPage": true,
        "id": "Market_Madness"
    },

     // this Video post is going to the same post as "title": "Amazing Nightlife" Eyal Asked
    {
        "title": "Окунитесь в бурную ночную жизнь",
        // "sml_desc": "Забронируйте поездку в Тель-Авив уже сейчас!",
        "sml_desc": "",
        // "desc": "Хотели бы окунуться в бурную ночную жизнь?",
        "desc": "",
        "img": "Videos/crazy-night.jpg",
        "img_mob":"/Videos/video_mob/crazy-night.jpg",
        "side_img": "Videos/sidebar/crazy-night.jpg",
        "read_more": "Прочитать больше",
        "link": "/Posts/index.php?post=Amazing_Nightlife",
        "vidId": "ogEN7aRT0SM",
        "ctg": "telaviv",
        "isVid": true,
        "forVidPage": true,
        "id": "Amazing_Nightlife"
    },
    // END this Video post is going to the same post as "title": "Amazing Nightlife" Eyal Asked

    {
        "title": "Иерусалим",
        // "sml_desc": "Иерусалим - сердце целого мира",
        "sml_desc": "",
        // "desc": "",
        "desc": "",
        "img": "Videos/heart-of-the-world.jpg",
        "img_mob":"/Videos/video_mob/heart-of-the-world.jpg",
        "side_img": "Videos/sidebar/heart-of-the-world.jpg",
        "read_more": "Прочитать больше",
        "link": "/Posts/index.php?post=Heart_Of_The_World",
        "vidId": "nLKWDp5uA-U",
        "ctg": "jerusalem",
        "isVid": true,
        "forVidPage": true,
        "id": "Heart_Of_The_World"
    },

    {
        "title": "2 УДИВИТЕЛЬНЫХ ГОРОДА",
        // "sml_desc": "Один солнечный отпуск",
        "sml_desc": "",
        "desc": "",
        "img": "/PostCarousel/Jerusalem/tw-awesome-cities.jpg",
        "side_img": "/PostCarousel/Jerusalem/tw-awesome-cities.jpg",
        "read_more": "Прочитать больше",
        "link": "/Posts/index.php?post=2_AWESOME_CITIES",
        "isVid": false,
        "forVidPage": true,
        "ctg": "telavivAndJerusalem",
        "id": "2_AWESOME_CITIES"
    },
    {
       "title": "ВЕЧНЫЙ ГОРОД",
        "sml_desc" : "",
         "desc" : "",
        "img": "/PostCarousel/Jerusalem/jerusalem.jpg",
        "side_img": "/PostCarousel/Jerusalem/jerusalem.jpg",
        "read_more": "Прочитать больше",
        "link": "/Posts/index.php?post=Jerusalem",
        "isVid": false,
        "forVidPage": true,
        "ctg": "jerusalem",
        "id": "Jerusalem"
    },
    {
        "title": "МЕРТВОЕ МОРЕ",
        // "sml_desc": "TAKE RELAXATION TO THE NEXT LEVEL",
        "sml_desc": "",
        "desc": "",
        "img": "/PostCarousel/DeadSea/next-level.jpg",
        "side_img": "/PostCarousel/DeadSea/next-level.jpg",
        "read_more": "Прочитать больше",
        "link": "/Posts/index.php?post=Next_Level_DS",
        "isVid": false,
        "forVidPage": true,
        "ctg": "deadsea",
        "id": "Next_Level_DS"
    },

    {
        "title": "ТЕЛЬ-АВИВ",
        "sml_desc": "",
        "desc": "",
        "img": "/PostCarousel/TelAviv/post-telaviv.jpg",
        "side_img": "/PostCarousel/TelAviv/post-telaviv.jpg",
        "read_more": "Прочитать больше",
        "link": "/Posts/index.php?post=Tel_Aviv",
        "isVid": false,
        "forVidPage": true,
        "ctg": "telaviv",
        "id": "Tel_Aviv"
    },
    // {
    //    "title": "Jerusalem’s Old City",
    //     "sml_desc" : "",
    //      // "sml_desc": "Jerusalem’s Old City",
    //      "desc" : "",
    //      // "desc": "Sensational sites of Ancient Times",
    //     "img": "/PostCarousel/Jerusalem/jerusalem-old-city.jpg",
    //     "side_img": "/PostCarousel/Jerusalem/jerusalem-old-city.jpg",
    //     "read_more": "Прочитать больше",
    //     "link": "/Posts/index.php?post=Jerusalem_Old_City",
    //     "isVid": false,
    //     "ctg": "jerusalem",
    //     "id": "Jerusalem_Old_City"
    // },
    // {
    //    "title": "NATURE'S GLORY",
    //     // "sml_desc": "THE DEAD SEA",
    //     "sml_desc": "",
    //     "desc": "",
    //     "img": "/PostCarousel/DeadSea/natures-glory.jpg",
    //     "side_img": "/PostCarousel/DeadSea/natures-glory.jpg",
    //     "read_more": "Прочитать больше",
    //     "link": "/Posts/index.php?post=Natures_Glory",
    //     "isVid": false,
    //     "ctg": "deadsea",
    //     "id": "Natures_Glory"
    // },
    {
        "title": "ПРЕЛЕСТИ МЁРТВОГО МОРЯ",
        // "sml_desc": "Для бесконечно приятного времяпрепровождения",
        "sml_desc": "",
        "desc": "",
        "img": "/PostCarousel/DeadSea/deadsea2.jpg",
         "img_mob":"/PostCarousel/video_mob/100.jpg",
        "side_img": "/PostCarousel/DeadSea/deadsea2.jpg",
        "read_more": "Прочитать больше",
        "link": "/Posts/index.php?post=Dead_Sea2",
        "isVid": true,
        "forVidPage": true,
        "vidId": "9aDP-jV6soE",
        "ctg": "deadsea",
        "id": "Dead_Sea2"
    },
    {
        "title": "Иерусалим и Тель-Авив",
        // "sml_desc": "Менее чем в одном часе путешествия!",
        "sml_desc": "",
        "desc": "",
        "img": "/PostCarousel/34.jpg",
        "side_img": "/PostCarousel/34.jpg",
        "read_more": "Прочитать больше",
        "link": "/Posts/index.php?post=Go_To_Guide",
        "ctg": "telaviv",
        "isVid": false,
        // "id": 35
        "id": "Go_To_Guide"
    },
    // {
    //     "title": "ALL SENSORY MARKETS",
    //     "sml_desc": "",
    //     "desc": "",
    //     "img": "thingsToDo/8.jpg",
    //     "side_img": "thingsToDo/sidebar/8.jpg",
    //     "read_more": "Прочитать больше",
    //     "link": "/Posts/index.php?post=20",
    //     "css_class": "unic_video-post-1",
    //     "vidId": "88OV6xU0vPI",
    //     "isVid": false,
    //     "id": "All_Sensory_Markets",
    //     "showOnHome": false,
    //     "ctg": "jerusalem"

    // },
    //  {
    //    "title": "THE DEAD SEA NATURAL SPA",
    //     "sml_desc" : "",
    //     // "sml_desc": "THE DEAD SEA",
    //     "desc" : "",
    //     "img": "/PostCarousel/DeadSea/natural-spa.jpg",
    //     "side_img": "/PostCarousel/DeadSea/natural-spa.jpg",
    //     "read_more": "Прочитать больше",
    //     "link": "/Posts/index.php?post=Natural_Spa",
    //     "isVid": false,
    //     "ctg": "deadsea",
    //     "id": "Natural_Spa"
    // },
    // {
    //    "title": "Jaffa Port ",
    //     // "sml_desc": "The different charms of<br> Tel Aviv and Jaffa Ports ",
    //     "sml_desc" : "",
    //     // "desc": "Tel Aviv’s fascinating cultural scene",
    //      "desc" : "",
    //     "img": "/PostCarousel/TelAviv/jaffa-port.jpg",
    //     "side_img": "/PostCarousel/TelAviv/jaffa-port.jpg",
    //     "read_more": "Прочитать больше",
    //     "link": "/Posts/index.php?post=Port_Pleasures",
    //     "isVid": false,
    //     "ctg": "telaviv",
    //     "id": "Port_Pleasures"
    // },
    // {
    //     "title": "Upscale Jerusalem",
    //     // "sml_desc": "Modern luxuries for the pampered traveler",
    //     "sml_desc": "",
    //     "desc": "",
    //     "img": "/PostCarousel/Jerusalem/45.jpg",
    //     "side_img": "/PostCarousel/Jerusalem/45.jpg",
    //     "read_more": "Прочитать больше",
    //     "link": "/Posts/index.php?post=45",
    //     "isVid": false,
    //     "ctg": "jerusalem",
    //     "id": 45
    // },
    // {
    //    "title": "NATURAL PHENOMENA",
    //     // "sml_desc": "THE DEAD SEA",
    //      "sml_desc": "",
    //     "desc" : "",
    //     "img": "/PostCarousel/DeadSea/natural-phenomena.jpg",
    //     "side_img": "/PostCarousel/DeadSea/natural-phenomena.jpg",
    //     "read_more": "Прочитать больше",
    //     "link": "/Posts/index.php?post=Natural_Phenomena",
    //     "isVid": false,
    //     "ctg": "deadsea",
    //     "id": "Natural_Phenomena"
    // },
    {
        // "title": "A Foodie’s Paradise‘",
        "title" : "Просто восхитительный вкус",
        // "sml_desc": "Сотни знаменитых ресторанов, удивительные <br> продукты и вкусная уличная еда",
        "sml_desc": "",
        // "desc": "Настоящий рай <br>для гурманов",
        "desc": "",
        "img": "/PostCarousel/99.jpg",
        "img_mob":"/PostCarousel/video_mob/99.jpg",
        "side_img": "/PostCarousel/99.jpg",
        "read_more": "Прочитать больше",
        "link": "/Posts/index.php?post=21",
        "ctg": "culinarytelaviv",
        "vidId": "n4kCnPXEX7g",
        "isVid": true,
        "forVidPage": true,
        "id": "Simply_Delicious"
    },
    {
        "title": "Иерусалимские сюрпризы",
        // "sml_desc": "Город превосходящий ожидания",
        "sml_desc": "",
        "desc": "",
        "img": "/PostCarousel/38.jpg",
        "side_img": "/PostCarousel/38.jpg",
        "read_more": "Прочитать больше",
        "link": this.url + "/Posts/index.php?post=Cool Jerusalem",
        "ctg": "jerusalem",
        "isVid": false,
        "forVidPage": true,
        "id": "Cool_Jerusalem"
    },
    {
       "title": "МЕРТВОЕ МОРЕ",
        "sml_desc" : "",
        "desc" : "",
        "img": "/PostCarousel/DeadSea/magical-deadsea.jpg",
        "side_img": "/PostCarousel/DeadSea/magical-deadsea.jpg",
        "read_more": "Прочитать больше",
        "link": "/Posts/index.php?post=Magical_Deadsea",
        "isVid": false,
        "forVidPage": true,
        "ctg": "deadsea",
        "id": "Magical_Deadsea"
    },
     {
        "title": "ОБЯЗАТЕЛЬНО В ИЕРУСАЛИМЕ",
        // "sml_desc": "5 самых популярных вещей, которые нужно сделать, и мест, которые вы должны увидеть в потрясающем городе",
        "sml_desc": "",
        "desc": "",
        "img": "/PostCarousel/18.jpg",
        "side_img": "/PostCarousel/18.jpg",
        "read_more": "Прочитать больше",
        "link": "/Posts/index.php?post=Jerusalem_Musts",
        "isVid": false,
        "forVidPage": true,
        "ctg": "jerusalem",
        "id": "Jerusalem_Musts"
    },
    {
        "title": "УДИВИТЕЛЬНАЯ НОЧНАЯ ЖИЗНЬ",
        "sml_desc": "",
        // "sml_desc": "УДИВИТЕЛЬНАЯ НОЧНАЯ ЖИЗНЬ",
        "desc": "",
        // "desc": "Вечеринка нон-стоп в городе, котрый никогда не спит",
        "img": "/PostCarousel/TelAviv/amazing-nightlife.jpg",
        "side_img": "/PostCarousel/TelAviv/amazing-nightlife.jpg",
        "read_more": "Прочитать больше",
        "link": "/Posts/index.php?post=Amazing_Nightlife",
        "isVid": false,
        "forVidPage": true,
        "ctg": "telaviv",
        "id": "Amazing_Nightlife"
    },
    
     
    {
        "title": "ВОЛШЕБНЫЙ ЯФФО",
        // "sml_desc": "ЯФФА: Город, чарующий <Br/> культурным многообразием",
        "sml_desc": "",
        // "desc": "Откройте для себя <Br/> сокровища прекрасной древней Яффы",
        "desc": "",
        "img": "Videos/magic-jaffa.jpg",
        "img_mob":"/Videos/video_mob/magic-jaffa.jpg",
        "side_img": "Videos/sidebar/magic-jaffa.jpg",
        "read_more": "Прочитать больше",
        "link": "/Posts/index.php?post=Magic_JAffa",
        "vidId": "FRmgXjfVPoE",
        "ctg": "telaviv",
        "isVid": true,
        "forVidPage": true,
        "id": "Magic_JAffa"
    },

    

    
    // {
    //    "title": "MASADA",
    //     "sml_desc" : "",
    //     "desc" : "",
    //     "img": "/PostCarousel/DeadSea/masada.jpg",
    //     "side_img": "/PostCarousel/DeadSea/masada.jpg",
    //     "read_more": "Прочитать больше",
    //     "link": "/Posts/index.php?post=Masada",
    //     "isVid": false,
    //     "ctg": "deadsea",
    //     "id": "Masada"
    // },
    {
        "title": "Яркие моменты Тель-Авива",
        // "sml_desc": "Топ-5 вещей, которые стоит <br>увидеть и сделать в городе",
         "sml_desc": "",
        "desc": "",
        "img": "/PostCarousel/17.jpg",
        "side_img": "/PostCarousel/17.jpg",
        "read_more": "Прочитать больше",
        "link": "/Posts/index.php?post=17",
        "ctg": "telaviv",
        "isVid": false,
        "forVidPage": true,
        "id": "TelAviv_Moments"
    },
    // {
    //     "title": "First Time in Jerusalem",
    //     // "sml_desc": "The must list for the first time visitor",
    //     "sml_desc": "",
    //     "desc": "",
    //     "img": "/PostCarousel/Jerusalem/first-in-jerusalem.jpg",
    //     "side_img": "/PostCarousel/Jerusalem/first-in-jerusalem.jpg",
    //     "read_more": "Прочитать больше",
    //     "link": "/Posts/index.php?post=First_Time_In_Jerusalem",
    //     "isVid": false,
    //     "ctg": "jerusalem",
    //     "id": "First_Time_In_Jerusalem"
    // },
    {
        "title": "Роскошь в центре Тель-Авива",
        "sml_desc": "",
        "desc": "",
        "img": "/PostCarousel/TelAviv/boutique-hospitality.jpg",
        "side_img": "/PostCarousel/TelAviv/boutique-hospitality.jpg",
        "read_more": "Прочитать больше",
        "link": "/Posts/index.php?post=Boutique_Hospitality",
        "isVid": false,
        "ctg": "telaviv",
        "id": "Boutique_Hospitality"
    },
    {
        "title": "Попробуйте в Иерусалиме",
        // "sml_desc": "Обязательно попробовать в Иерусалиме",
        "desc": "",
        "sml_desc": "",
        "img": "/PostCarousel/37.jpg",
         "img_mob":"/PostCarousel/video_mob/37.jpg",
        "side_img": "/PostCarousel/37.jpg",
        "read_more": "Прочитать больше",
        "link": "/Posts/index.php?post=38",
        "ctg": "culinaryjerusalem",
        "vidId": "2CSCe2WC7Ns",
        "isVid": true,
        "forVidPage": true,
        "id": "A_Taste_Of_Jerusalem"
    },
    
    {
       "title": "ВОЛШЕБНЫЙ СТАРЫЙ ГОРОД",
        "sml_desc" : "",
         "desc" : "",
        "img": "/PostCarousel/Jerusalem/secrets-jer.jpg",
        "side_img": "/PostCarousel/Jerusalem/secrets-jer.jpg",
        "read_more": "Прочитать больше",
        "link": "/Posts/index.php?post=Sectrets_Of_Jewish_Jerusalem",
        "isVid": false,
        "ctg": "jerusalem",
        "id": "Sectrets_Of_Jewish_Jerusalem"
    },
    {
       "title": "ГАСТРОНОМИЧЕСКИЕ ДОСТОПРИМЕЧАТЕЛЬНОСТИ",
        "sml_desc" : "",
         "desc" : "",
        "img": "/PostCarousel/TelAviv/gastronomic-atractions-telaviv.jpg",
        "side_img": "/PostCarousel/TelAviv/gastronomic-atractions-telaviv.jpg",
        "read_more": "Прочитать больше",
        "link": "/Posts/index.php?post=Gastronomic_Atractions_Telaviv",
        "isVid": false,
        "forVidPage": true,
        "ctg": "telaviv",
        "id": "Gastronomic_Atractions_Telaviv"
    },
    // {
    //     "title": "Non Stop Markets",
    //     "sml_desc": "",
    //     "desc": "",
    //     "img": "/PostCarousel/TelAviv/non-stop-markets.jpg",
    //     "side_img": "/PostCarousel/TelAviv/non-stop-markets.jpg",
    //     "read_more": "Прочитать больше",
    //     "link": "/Posts/index.php?post=Non_Stop_Markets",
    //     "isVid": false,
    //     "ctg": "telaviv",
    //     "id": "Non_Stop_Markets"
    // },
    {
       "title": "БУЛЬВАР МАМИЛА",
        "sml_desc" : "",
        "desc" : "",
        "img": "/PostCarousel/Jerusalem/mamila-avenue.jpg",
        "side_img": "/PostCarousel/Jerusalem/mamila-avenue.jpg",
        "read_more": "Прочитать больше",
        "link": "/Posts/index.php?post=Mamilla_Avenue",
        "isVid": false,
        "forVidPage": true,
        "ctg": "jerusalem",
        "id": "Mamilla_Avenue"
    },
    // {
    //     "title": "Joys of Jaffa",
    //     "sml_desc": "",
    //     // "sml_desc" : "Ancient, Artsy and Fabulous",
    //     "desc": "",
    //      // "desc" : "Experience all the riches the beautiful ancient Jaffa has to offer",
    //     "img": "/PostCarousel/TelAviv/joys-of-jaffa.jpg",
    //     "side_img": "/PostCarousel/TelAviv/joys-of-jaffa.jpg",
    //     "read_more": "Прочитать больше",
    //     "link": "/Posts/index.php?post=Joys_Of_Jaffa",
    //     "isVid": false,
    //     "ctg": "telaviv",
    //     "id": "Joys_Of_Jaffa"
    // },
    // {
    //     "title": "TOWER OF DAVID MUSEUM",
    //     "sml_desc": "",
    //     "img": "thingsToDo/7.jpg",
    //     "side_img": "thingsToDo/sidebar/7.jpg",
    //     "read_more": "Прочитать больше",
    //     "link": "/Posts/index.php?post=20",
    //     "css_class": "unic_video-post-1",
    //     "vidId": "88OV6xU0vPI",
    //     "isVid": false,
    //     "id": "Tower_Of_David_Museum",
    //     "showOnHome": false,
    //     "ctg": "jerusalem"

    // },
    {
        "title": "ПРИМОРСКИЙ ТЕЛЬ-АВИВ",
        // "sml_desc": "Потому что Тель-Авив <Br/>невозможно представить без пляжей ",
        "sml_desc": "",
        // "desc": "Не сомневайтесь, вы получите огромное<br> удовольствие на солнышке",
        "desc": "",
        "img": "Videos/a.jpg",
        "img_mob":"/Videos/video_mob/a.jpg",
        "side_img": "Videos/sidebar/a.jpg",
        "read_more": "Прочитать больше",
        "link": "/Posts/index.php?postType=video&post=3",
        "css_class": "unic_video-post-4",
        "vidId": "PdTkXbiBpFs",
        "ctg": "telaviv",
        "isVid": true,
        "forVidPage": true,
        "id": "TelAviv_By_The_Sea"
    },
    {
        "title": "КОФЕЙНАЯ ЖИЗНЬ ТЕЛЬ-АВИВА",
        // "sml_desc": "Tel Aviv over a fresh coffee",
        "sml_desc": "",
        // "desc": "Coffee shop culture is fundamental",
        "desc":" ",
        "img": "Videos/coffee.jpg",
         "img_mob":"/Videos/video_mob/coffee.jpg",
        "side_img": "Videos/sidebar/coffee.jpg",
        "read_more": "Прочитать больше",
        "link": "/Posts/index.php?postType=video&post=16",
        "vidId": "rVr0gqFC364",
        "ctg": "culinarytelaviv",
        "isVid": true,
        "forVidPage": true,
        "id": "Coffee_In_TelAviv"
    },
    {
       "title": "ИЕРУСАЛИМ-ЦЕНТР ИСКУССТВА",
        "sml_desc" : "",
        "desc" : "",
        "img": "/PostCarousel/Jerusalem/jerusalem-art.jpg",
        "side_img": "/PostCarousel/Jerusalem/jerusalem-art.jpg",
        "read_more": "Прочитать больше",
        "link": "/Posts/index.php?post=Jerusalem_Arts",
        "isVid": false,
        "ctg": "jerusalem",
        "id": "Jerusalem_Arts"
    },
    {
        "title": "Неве Цедек",
        "sml_desc": "",
        // "sml_desc" : "Шик и <br>уникальность  ",
        // "desc": "Множество уютных кафе, бутиков, галерей<br> и расслабленная атмосфер",
         "desc": "",
        "img": "Videos/j.jpg",
        "img_mob":"/Videos/video_mob/j.jpg",
        "side_img": "Videos/sidebar/j.jpg",
        "read_more": "Прочитать больше",
        "vidId": "F6n-WK0RHk0",
        "link": "/Posts/index.php?postType=video&post=7",
        "css_class": "unic_video-post-13",
        "ctg": "telaviv",
        "isVid": true,
        "forVidPage": true,
        "id": "Neve_Tzedek"
    },
    {
       "title": "КУХНЯ ИЕРУСАЛИМА",
        "sml_desc" : "Разнообразие вкусных блюд",
        "desc" : "",
        "img": "/PostCarousel/Jerusalem/jerusalem-kitchen.jpg",
        "side_img": "/PostCarousel/Jerusalem/jerusalem-kitchen.jpg",
        "read_more": "Прочитать больше",
        "link": "/Posts/index.php?post=Jerusalem-Kitchen",
        "css_class": "unic_video-post-jerusalem-kitchen",
        "isVid": false,
        "forVidPage": true,
        "ctg": "jerusalem",
        "id": "Jerusalem_Kitchen"
    },

    {
        "title": "ОТДЫХ БЕЗ ОГРАНИЧЕНИЙ",
        "sml_desc": "",
        // "sml_desc" : "",
        // "desc": "Яркий и захватывающий, прекрасный Тель-Авив",
         "desc": "",
        "img": "PostCarousel/unlimited-relax.jpg",
        "side_img": "PostCarousel/unlimited-relax.jpg",
        "read_more": "Прочитать больше",
        "vidId": "F6n-WK0RHk0",
        "link": "/Posts/index.php?Unlimited_Relax",
        "css_class": "unic_post-unlimited-relax",
        "ctg": "telaviv",
        "forVidPage": true,
        "isVid": false,
        "id": "Unlimited_Relax"
    },
    // {
    //    "title": "MUST EAT IN JERUSALEM",
    //     "sml_desc" : "",
    //     "desc" : "",
    //     "img": "/PostCarousel/Jerusalem/must-eat-in-jer.jpg",
    //     "side_img": "/PostCarousel/Jerusalem/must-eat-in-jer.jpg",
    //     "read_more": "Прочитать больше",
    //     "link": "/Posts/index.php?post=Must_Eat_In_Jerusalem",
    //     "isVid": false,
    //     "ctg": "jerusalem",
    //     "id": "Must_Eat_In_Jerusalem"
    // },
    {
        "title": "Рай для веганов ",
        // "sml_desc": "Рай для веганов Познакомьтесь с огромным выбором вкуснейших веганских блюд и даже веганское мороженое!",
        // "desc": "Избранное лучшим <Br/>местом в мире для веганов",
        "sml_desc": "",
        "desc": "",
        "img": "Videos/h.jpg",
        "img_mob":"/Videos/video_mob/h.jpg",
        "side_img": "Videos/sidebar/h.jpg",
        "vidId": "Tub5VbKN4lQ",
        "read_more": "Прочитать больше",
        "link": "/Posts/index.php?post=6",
        "ctg": "culinarytelaviv",
        "isVid": true,
        "forVidPage": true,
        "id": "Vegan_Friendly_TelAviv"
    },
    {
        "title": "Шоппинг в удовольствие",
        // "sml_desc": "От модной одежды до <br>сувениров – все это в Иерусалиме",
        "sml_desc": "",
        "desc": "",
        "img": "/PostCarousel/5.jpg",
        "side_img": "/PostCarousel/5.jpg",
        "read_more": "Прочитать больше",
        "link": "/Posts/index.php?post=Shopping_Delights",
        "ctg": "jerusalem",
        "isVid": false,
        "forVidPage": true,
        "id": "Shopping_Delights"
    },
    {
        "title": "Что делать в Тель-Авиве",
        // "sml_desc": "Cool things to do in the hot city",
        "sml_desc": "",
        "desc": "",
        "img": "/PostCarousel/40.jpg",
        "side_img": "/PostCarousel/40.jpg",
        "read_more": "Прочитать больше",
        "link": "/Posts/index.php?post=TelAviv_Adventures",
        "ctg": "telaviv",
        "isVid": false,
        "id": "TelAviv_Adventures"
    },

    {
        "title": "ТЕЛЬ-АВИВ ДЛЯ ВЕГЕТАРИАНЦЕВ",
        // "sml_desc": "Лучшие вегетарианские рестораны Тель-Авива",
        "sml_desc": "",
        "desc": "",
        "img": "/PostCarousel/6.jpg",
        "side_img": "/PostCarouse/6.jpg",
        "read_more": "Прочитать больше",
        "link": "/Posts/index.php?post=Vegan_Friendly_TelAviv_Post",
        "ctg": "telaviv",
        "isVid": false,
        "forVidPage": true,
        "id": "Vegan_Friendly_TelAviv_Post"
    },
    {
        "title": "МАХАНЕ ЙЕГУДА",
        // "sml_desc": "Ночная жизнь на рынке Махане Иегуда",
        "sml_desc": "",
        "desc": "",
        "img": "/PostCarousel/7.jpg",
        "side_img": "/PostCarouse/7.jpg",
        "read_more": "Прочитать больше",
        "link": "/Posts/index.php?post=Market_Madness_Post",
        "ctg": "culinaryjerusalem",
        "isVid": false,
        "forVidPage": true,
        "id": "Market_Madness_Post"
    },
    

    {
        "title": "Развлечения для всей семьи",
        // "sml_desc": "Беспрерывные развлечения<br> для всей семьи",
        "sml_desc": "",
        "desc": "",
        "img": "/PostCarousel/33.jpg",
        "side_img": "/PostCarousel/33.jpg",
        "read_more": "Прочитать больше",
        "link": "/Posts/index.php?post=25",
        "isVid": false,
        "ctg": "telavivAndJerusalem",
        "id": "Travel_With_Family"
    },
    // {
    //     "title": "UNFORGETTABLE YAD VASHEM",
    //     "sml_desc": "",
    //     "img": "thingsToDo/10.jpg",
    //     "side_img": "thingsToDo/sidebar/10.jpg",
    //     "read_more": "Прочитать больше",
    //     "link": "/Posts/index.php?post=20",
    //     "css_class": "unic_video-post-1",
    //     "vidId": "88OV6xU0vPI",
    //     "isVid": false,
    //     id: 31,
    //     "showOnHome": false,
    //     "ctg": "jerusalem"

    // },
    {
        "title": "Сарона в Тель-Авиве",
        "desc": "",
        // "desc": "Великолепный оазис в <br>урбанистическом окружении",
        // "sml_desc": "Множество интересного<Br/> в реставрированной колонии темплеров",
        "sml_desc": "",
        "img": "Videos/d.jpg",
        "img_mob":"/Videos/video_mob/d.jpg",
        "side_img": "Videos/sidebar/d.jpg",
        "read_more": "Прочитать больше",
        "link": "/Posts/index.php?postType=video&post=Sarona_TelAviv",
        "vidId": "bWY_8bHq3as",
        "ctg": "telaviv",
        "isVid": true,
        "forVidPage": true,
        "id": "Sarona_TelAviv"
    },
    {
       "title": "ИЕРУСАЛИМСКИЕ ВОРОТА",
        "sml_desc" : "",
        "desc" : "",
        "img": "/PostCarousel/Jerusalem/gates.jpg",
        "side_img": "/PostCarousel/Jerusalem/gates.jpg",
        "read_more": "Прочитать больше",
        "link": "/Posts/index.php?post=The_Gates_Of_Jerusalem",
        "isVid": false,
        "forVidPage": true,
        "ctg": "jerusalem",
        "id": "The_Gates_Of_Jerusalem"
    },
    {
        "title": "Один день в Тель-Авиве",
        "sml_desc": "",
        // "sml_desc" : "Day isTrippin’",
        "desc": "",
         // "desc" : "От порта к порту",
        "img": "/PostCarousel/TelAviv/day-is-trippin.jpg",
        "side_img": "/PostCarousel/TelAviv/day-is-trippin.jpg",
        "read_more": "Прочитать больше",
        "link": "/Posts/index.php?post=Day_IsTrippin",
        "isVid": false,
        "ctg": "telaviv",
        "id": "Day_IsTrippin"
    },
    {
        "title": "Туристическая информация",
        // "sml_desc": "Все, что вам нужно знать",
        "sml_desc": "",
        "desc": "",
        "img": "/PostCarousel/touristinfo.jpg",
        "side_img": "/PostCarousel/touristinfo.jpg",
        "read_more": "Weiterlesen",
        "link": "/Posts/index.php?post=Tourist_info",
        "isVid": false,
        "ctg": "telaviv",
        "id": "Tourist_info"
    },
    // {
    //     "title": "JERUSALEM MAIN SITES",
    //     // "sml_desc": "Travel back thousands of years",
    //     "sml_desc": "",
    //     "desc": "",
    //     "img": "/PostCarousel/Jerusalem/main-sites-jer.jpg",
    //     "side_img": "/PostCarousel/Jerusalem/main-sites-jer.jpg",
    //     "read_more": "Прочитать больше",
    //     "link": "/Posts/index.php?post=9",
    //     "isVid": false,
    //     "ctg": "jerusalem",
    //     "id": 99
    // },
    {
        "title": "Центр кулинарного искусства",
        // "sml_desc": "Пробудите свои вкусовые<br> рецепторы в Тель-Авиве",
        "sml_desc": "",
        // "desc": "Тель-Авив предлагает огромный<br> выбор великолепных ресторанов",
        "desc": "",
        "img": "Videos/e.jpg",
        "img_mob":"/Videos/video_mob/e.jpg",
        "side_img": "Videos/sidebar/e.jpg",
        "read_more": "Прочитать больше",
        "link": "/Posts/index.php?postType=video&post=33",
        "vidId": "jfyHxk8ZRrI",
        "ctg": "culinarytelaviv",
        "isVid": true,
        "forVidPage": true,
        "id": "Gourmet_TelAviv"
    },
    // {
    //     "title": "WESTERN WALL WONDERS",
    //     "sml_desc": "",
    //     "img": "thingsToDo/4.jpg",
    //     "side_img": "thingsToDo/sidebar/4.jpg",
    //     "read_more": "Прочитать больше",
    //     "link": "/Posts/index.php?post=Western_Wall_Wonders",
    //     "css_class": "unic_video-post-Western_Wall_Wonders",
    //     "vidId": "88OV6xU0vPI",
    //     "isVid": false,
    //     "id": "Western_Wall_Wonders",
    //     "ctg": "jerusalem",
    //     "showOnHome": false,

    // },
    // {
    //     "title": "Travelling on a Budget",
    //     // "sml_desc": "Making it count in Tel Aviv and Jerusalem!",
    //     "sml_desc": "",
    //     "desc": "",
    //     "img": "/PostCarousel/44.jpg",
    //     "side_img": "/PostCarousel/44.jpg",
    //     "read_more": "Прочитать больше",
    //     "link": "/Posts/index.php?post=44",
    //     "isVid": false,
    //     "ctg": "telavivAndJerusalem",
    //     "id": 44
    // },
    {
       "title": "УНИКАЛЬНЫЕ ПОКУПКИ В ИЗРАИЛЕ",
        "sml_desc" : "",
        "desc" : "",
        "img": "/PostCarousel/Jerusalem/unique.jpg",
        "side_img": "/PostCarousel/Jerusalem/unique.jpg",
        "read_more": "Прочитать больше",
        "link": "/Posts/index.php?post=Purchases_In_Israel",
        "isVid": false,
        "ctg": "jerusalem",
        "id": "Purchases_In_Israel"
    },
    // {
    //    "title" : "Tel Aviv street food",
    //     // "sml_desc" : "Tel Aviv street food",
    //     "sml_desc" : "",
    //     // "desc" : "A true world-class foodie destination",
    //      "desc" : "",
    //     "img": "/PostCarousel/TelAviv/streetfood-telaviv.jpg",
    //     "side_img": "/PostCarousel/TelAviv/streetfood-telaviv.jpg",
    //     "read_more": "Прочитать больше",
    //     "link": "/Posts/index.php?post=Tel_Aviv_Street_Food",
    //     "isVid": false,
    //     "ctg": "telaviv",
    //     "id": "Tel_Aviv_Street_Food"
    // },
    // {
    //    "title": "JERUSALEM FUN",
    //     "sml_desc" : "",
    //     "desc" : "",
    //     "img": "/PostCarousel/Jerusalem/jerusalem-fun.jpg",
    //     "side_img": "/PostCarousel/Jerusalem/jerusalem-fun.jpg",
    //     "read_more": "Прочитать больше",
    //     "link": "/Posts/index.php?post=Jerusalem_Fun",
    //     "isVid": false,
    //     "ctg": "jerusalem",
    //     "id": "Jerusalem_Fun"
    // },
    {
        "title": "Тель-Авив",
        // "desc": "Велосипедные путешествия Тель-Авивом",
        "sml_desc": "",
        "desc": "",
        "img": "PostCarousel/39.jpg",
        "side_img": "PostCarousel/39.jpg",
        "read_more": "Прочитать больше",
        "link": "/Posts/index.php?post=39",
        "ctg": "telaviv",
        "isVid": false,
        "forVidPage": true,
        "id": "TelAviv_Cycle"
    },
   


    {
        "title": "Рай для гурмана",
        // "sml_desc": "Познакомьтесь с удивительной <br>кулинарной сценой Тель-Авива",
        "sml_desc": "",
        "desc": "",
        "img": "/PostCarousel/heaven.jpg",
        "side_img": "/PostCarousel/heaven.jpg",
        "read_more": "Прочитать больше",
        "link": "/Posts/index.php?post=Gourme_Heaven",
        "isVid": false,
        "forVidPage": true,
        "ctg": "telaviv",
        "id": "Gourme_Heaven"
    },


    {
        "title": "ВРЕМЯ ШАКШУКИ",
        // "sml_desc": "Познакомьтесь с удивительной <br>кулинарной сценой Тель-Авива",
        "sml_desc": "",
        "desc": "",
        "img": "/PostCarousel/22.jpg",
        "side_img": "/PostCarousel/22.jpg",
        "read_more": "Прочитать больше",
        "link": "/Posts/index.php?post=Shakshuka_Time",
        "isVid": true,
        "forVidPage": true,
        "ctg": "culinary",
        "vidId":"n4kCnPXEX7g",
        "id": "Shakshuka_Time"
    },
    // {
    //     "title": "ULTIMATE BEACH FUN",
    //     "sml_desc": "",
    //     // "desc": "Join the ride in the city that doesn't stop \n Get your wheels on and go anywhere they take you in this fabulous city",
    //     "desc": "",
    //     "img": "/PostCarousel/TelAviv/ultimate-beaches.jpg",
    //     "img_mob":"/PostCarousel/video_mob/ultimate-beaches.jpg",
    //     "side_img": "/PostCarousel/TelAviv/ultimate-beaches.jpg",
    //     "read_more": "Прочитать больше",
    //     "link": "/Posts/index.php?post=24",
    //     "css_class": "unic_video-post-1",
    //     "vidId": "88OV6xU0vPI",
    //     "isVid": true,
    //     "id":"Ultimate_Beach_Fun",
    //     "ctg": "telaviv",
    //     "showOnHome": false,

    // },
    {
        "title": "СОВРЕМЕННЫЙ И ДИНАМИЧНЫЙ",
        // "sml_desc": "Достопримечательности в центре Иерусалима",
        "sml_desc": "",
        "desc": "",
        "img": "/PostCarousel/19.jpg",
        "side_img": "/PostCarousel/19.jpg",
        "read_more": "Прочитать больше",
        "link": "/Posts/index.php?post=Modern_And_Vibrant",
        "isVid": false,
        "forVidPage": true,
        "ctg": "jerusalem",
        "id": "Modern_And_Vibrant"
    },
    // {
    //     "title": "WHITE CITY SPLENDOR",
    //     "sml_desc": "",
    //     "desc": "",
    //     "img": "thingsToDo/6.jpg",
    //     "side_img": "thingsToDo/sidebar/6.jpg",
    //     "read_more": "Прочитать больше",
    //     "link": "/Posts/index.php?post=20",
    //     "css_class": "unic_video-post-1",
    //     "vidId": "88OV6xU0vPI",
    //     "isVid": false,
    //     id: 28,
    //     "showOnHome": false,
    //     "ctg": "telaviv"

    // },
    // {
    //    "title": "Jerusalem after dark fun",
    //     "sml_desc" : "",
    //     "desc" : "",
    //     "img": "/PostCarousel/Jerusalem/after-dark-fun.jpg",
    //     "side_img": "/PostCarousel/Jerusalem/after-dark-fun.jpg",
    //     "read_more": "Прочитать больше",
    //     "link": "/Posts/index.php?post=Jerusalem_After_Dark_Fun",
    //     "isVid": false,
    //     "ctg": "jerusalem",
    //     "id": "Jerusalem_After_Dark_Fun"
    // },
    {
        "title": "Тель-Авив",
        // "sml_desc": "Направление абсолютной роскоши",
        "sml_desc": "",
        // "desc": "Направление абсолютной роскоши",
        "desc": "",
        "img": "/PostCarousel/36.jpg",
        "side_img": "/PostCarousel/36.jpg",
        "read_more": "Прочитать больше",
        "link": "/Posts/index.php?post=37",
        "ctg": "telaviv",
        "isVid": false,
        "id": 37
    },
    {
       "title" : "Время культуры",
        // "sml_desc": "Non Stop Culture",
        "sml_desc" : "",
        // "desc": "Разнообразные увлекательные музеи и уникальные галереи",
         "desc" : "",
        "img": "/PostCarousel/TelAviv/culture-telaviv.jpg",
        "side_img": "/PostCarousel/TelAviv/culture-telaviv.jpg",
        "read_more": "Прочитать больше",
        "link": "/Posts/index.php?post=Non_Stop_Culture",
        "isVid": false,
        "forVidPage": false,
        "ctg": "telaviv",
        "id": "Non_Stop_Culture"
    },
    // {
    //     "title": "ALL SENSORY MARKETS",
    //     "sml_desc": "",
    //     "img": "thingsToDo/8.jpg",
    //     "side_img": "thingsToDo/sidebar/8.jpg",
    //     "read_more": "Прочитать больше",
    //     "link": "/Posts/index.php?post=20",
    //     "css_class": "unic_video-post-1",
    //     "vidId": "88OV6xU0vPI",
    //     "isVid": false,
    //     "id": "All_Sensory_Markets",
    //     "showOnHome": false,
    //     "ctg": "culinary"

    // },
    {
       "title": "РАЗВЛЕЧЕНИЯ В ПОРТУ",
        // "sml_desc": «Очарование портов Тель-Авива и Яффо»",
        "sml_desc" : "",
        // "desc": "Tel Aviv’s fascinating cultural scene",
         "desc" : "",
        "img": "/PostCarousel/3.jpg",
        "img_mob":"/PostCarousel/video_mob/3.jpg",
        "side_img": "/PostCarousel/3.jpg",
        "read_more": "Прочитать больше",
        "link": "/Posts/index.php?post=Port_Pleasures",
        "isVid": true,
        "forVidPage": true,
        "ctg": "telaviv",
        "vidId" : "FRmgXjfVPoE",
        "id": "Port_Pleasures"
    },

    {
       "title": "МЕРТВОЕ МОРЕ",
        // "sml_desc": "Вознеситесь на пик жизненной энергии в самой низкой точке планеты",
        "sml_desc" : "",
        // "desc": "Tel Aviv’s fascinating cultural scene",
         "desc" : "",
        "img": "/PostCarousel/DeadSea/natures-glory.jpg",
         "img_mob":"/PostCarousel/video_mob/natures-glory.jpg",
        "side_img": "/PostCarousel/DeadSea/natures-glory.jpg",
        "read_more": "Прочитать больше",
        "link": "/Posts/index.php?post=Dead_Sea_Video",
        "isVid": true,
        "forVidPage": true,
        "ctg": "deadsea",
        "vidId" : "ixFocykfYHo",
        "id": "Dead_Sea_Video"
    },
   
    {
        "title": "ДЖЕЙМИ ОЛИВЕР В Тель-Авиве",
        // "sml_desc": "ДЖЕЙМИ ОЛИВЕР ПРОБУЕТ ТЕЛЬ-АВИВСКИЙ ЗАВТРАК",
        "sml_desc": "",
        "desc": "",
        "img": "Videos/jamie-oliver.jpg",
        "img_mob":"/Videos/video_mob/jamie-oliver.jpg",
        "side_img": "Videos/sidebar/jamie-oliver.jpg",
        "vidId": "gGe4W8WaIiQ",
        "read_more": "Прочитать больше",
        "link": "/Posts/index.php?post=Jamie_Oliver",
        "ctg": "culinarytelaviv",
        "isVid": true,
        "forVidPage": true,
        "id": "Jamie_Oliver"
    },

    {
        "title": "СТАРЫЙ ГОРОД ИЕРУСАЛИМА",
        // "sml_desc": "Почувствуйте, как оживает<Br/> история перед вашими глазами",
        "sml_desc": "",
        // "desc": "Проникнитесь всемирно известными ценностями<br> старого города в Иерусалиме",
        "desc": "",
        "img": "Videos/m.jpg",
        "img_mob":"/Videos/video_mob/m.jpg",
        "side_img": "Videos/sidebar/m.jpg",
        "vidId": "gGe4W8WaIiQ",
        "read_more": "Прочитать больше",
        "link": "/Posts/index.php?post=Old_City_Jerusalem",
        "ctg": "jerusalem",
        "isVid": true,
        "forVidPage": true,
        "id": "Old_City_Jerusalem"
    },
    
    // {
    //     "title": "Party Capital",
    //     // "sml_desc": "Epic Nights in the non stop city",
    //     "sml_desc": "",
    //     "desc": "",
    //     "img": "/PostCarousel/42.jpg",
    //     "side_img": "/PostCarousel/42.jpg",
    //     "read_more": "Прочитать больше",
    //     "link": "/Posts/index.php?post=42",
    //     "isVid": false,
    //     "ctg": "telaviv",
    //     "id": "Party_Capital"
    // },
    {
        "title": "ПРЕКРАСНЫЕ ПЛЯЖИ",
        // "sml_desc": "Отдохните на солнечных пляжах Тель-Авива",
        "sml_desc": "",
        "desc": "",
        "img": "/PostCarousel/TelAviv/sensational-beaches2.jpg",
        "side_img": "/PostCarousel/TelAviv/sensational-beaches2.jpg",
        "read_more": "Прочитать больше",
        "link": "/Posts/index.php?post=Sensational_Beaches",
        "isVid": false,
        "forVidPage": true,
        "ctg": "telaviv",
        //"id": 14
        "id":"Sensational_Beaches"
    },
    {
        "title": "УВЛЕЧЕНИЯ БЕЗ ОГРАНИЧЕНИЙ",
        // "sml_desc": "Красивый, красочный и захватывающий – Удивительный Тель-Авив ",
        "sml_desc": "",
        "desc": "",
        "img": "/PostCarousel/TelAviv/nonstop-excitement2.jpg",
        "side_img": "/PostCarousel/TelAviv/nonstop-excitement2.jpg",
        "read_more": "Прочитать больше",
        "link": "/Posts/index.php?post=Nonstop_Excitement",
        "ctg": "telaviv",
        "isVid": false,
        "forVidPage": true,
        "id": "Nonstop_Excitement"
    },
    {
        "title": "ИЕРУСАЛИМСКИЙ ХУМУС",
        // "sml_desc": "Хотите попробовать лучший хумус? Путешествие начинается здесь",
        "sml_desc": "",
        "desc": "",
        "img": "/PostCarousel/15.jpg",
        "side_img": "/PostCarousel/15.jpg",
        "read_more": "Прочитать больше",
        "link": "/Posts/index.php?post=Jerusalem_Humus",
        "isVid": false,
        "ctg": "jerusalem",
        "id": "Jerusalem_Humus"
    },
    {
        "title": "Иерусалим зовет",
        // "sml_desc": "Самый волшебный и сияющий <br>город на Земле",
        "sml_desc": "",
        "desc": "",
        "img": "/PostCarousel/Jerusalem/jerusalem-calling.jpg",
        "side_img": "/PostCarousel/Jerusalem/jerusalem-calling.jpg",
        "read_more": "Прочитать больше",
        "link": "/Posts/index.php?post=Jerusalem_Journey_In_Time",
        "isVid": false,
        "forVidPage": true,
        "ctg": "jerusalem",
        "id": "Jerusalem_Journey_In_Time"
    },



    {
        "title": "ВЕЛИЧЕСТВЕННАЯ ПУСТЫНЯ",
        // "sml_desc": "Приключения под солнцем пустыни. В пустыне Негев вам будет некогда скучать, ведь здесь столько всего интересного",
        "sml_desc": "",
        "desc": "",
        "img": "/PostCarousel/16.jpg",
        "side_img": "/PostCarousel/16.jpg",
        "read_more": "Прочитать больше",
        "link": "/Posts/index.php?post=The_Desert_Negev",
        "isVid": false,
        "forVidPage": true,
        "ctg": "eilat-negev",
        "id": "The_Desert_Negev"
    },

    // Eilat Posts
        // {
        //  "title":"EILAT",
        //  "sml_desc":"",
        //  "desc":"",
        //  "img":"/PostCarousel/eilat1.jpg",
        //  "side_img":"/PostCarousel/eilat1.jpg",
        //  "read_more":"READ MORE",
        //  "link": "/Posts/index.php?post=EILAT1", 
        //  "css_class":"unic-post-EILAT1",
        //  "isVid" : false,
        //  "ctg"   : 'eilat-negev',
        //   "id"    : 'EILAT1'
        // },
        {
         "title":"ЭЙЛАТ СТРАНА ВЕЧНОГО ЛЕТА",
         "sml_desc":"",
         "desc":"",
         "img":"/PostCarousel/welcome-to-eilat.jpg",
         "side_img":"/PostCarousel/welcome-to-eilat.jpg",
         "read_more":"READ MORE",
         "link": "/Posts/index.php?post=Welcome_To_Eilat", 
         "css_class":"unic-post-welcome-to-eilat",
         "isVid" : false,
         "forVidPage": true,
         "ctg"   : 'eilat-negev',
          "id"    : 'Welcome_To_Eilat'
        },
        {
         "title":"ПРЕКРАСНЫЙ ОТПУСК В ЭЙЛАТЕ",
         "sml_desc":"",
         "desc":"",
         "img":"/PostCarousel/the-ultimate-holiday.jpg",
         "side_img":"/PostCarousel/the-ultimate-holiday.jpg",
         "read_more":"READ MORE",
         "link": "/Posts/index.php?post=The_Ultimate_Holiday", 
         "css_class":"unic-post-the-ultimate-holiday",
         "isVid" : false,
         "ctg"   : 'eilat-negev',
          "id"    : 'The_Ultimate_Holiday'
        },
        // {
        //  "title":"EILAT’S CALLING",
        //  "sml_desc":"",
        //  "desc":"",
        //  "img":"/PostCarousel/eilat-calling.jpg",
        //  "side_img":"/PostCarousel/eilat-calling.jpg",
        //  "read_more":"READ MORE",
        //  "link": "/Posts/index.php?post=Eilat_Calling", 
        //  "css_class":"unic-post-eilat-calling",
        //  "isVid" : false,
        //  "ctg"   : 'eilat-negev',
        //   "id"    : 'Eilat_Calling'
        // },
        {
         "title":"ДЕЛЬФИНИЙ РИФ В ЭЙЛАТЕ",
         "sml_desc":"",
         "desc":"",
         "img":"/PostCarousel/eilat-doolphin-reef.jpg",
         "side_img":"/PostCarousel/eilat-doolphin-reef.jpg",
         "read_more":"READ MORE",
         "link": "/Posts/index.php?post=Eilat_Doolphin_Reef", 
         "css_class":"unic-post-eilat-doolphin-reef",
         "isVid" : false,
         "forVidPage": true,
         "ctg"   : 'eilat-negev',
          "id"    : 'Eilat_Doolphin_Reef'
        },
        // {
        //  "title":"Action Packed Eilat",
        //  "sml_desc":"",
        //  "desc":"",
        //  "img":"/PostCarousel/action-packed-eilat.jpg",
        //  "side_img":"/PostCarousel/action-packed-eilat.jpg",
        //  "read_more":"READ MORE",
        //  "link": "/Posts/index.php?post=Action_Packed_Eilat", 
        //  "css_class":"unic-post-action-packed-eilat",
        //  "isVid" : false,
        //  "ctg"   : 'eilat-negev',
        //   "id"    : 'Action_Packed_Eilat'
        // },
        {
         "title":"ЗАДЕРЖАТЬ ВДОХ И НЫРНУТЬ",
         "sml_desc":"",
         "desc":"",
         "img":"/PostCarousel/eilat-ultimate-beachside.jpg",
         "side_img":"/PostCarousel/eilat-ultimate-beachside.jpg",
         "read_more":"READ MORE",
         "link": "/Posts/index.php?post=Eilat_Ultimate_Beachside", 
         "css_class":"unic-post-eilat-ultimate-beachside",
         "isVid" : false,
         "forVidPage": true,
         "ctg"   : 'eilat-negev',
          "id"    : 'Eilat_Ultimate_Beachside'
        },
        {
         "title":"НЕГЕВ ПОБЕГ В ПУСТЫНЮ",
         "sml_desc":"",
         "desc":"",
         "img":"/PostCarousel/negev-description.jpg",
         "side_img":"/PostCarousel/negev-description.jpg",
         "read_more":"READ MORE",
         "link": "/Posts/index.php?post=Negev_Description", 
         "css_class":"unic-post-negev-description",
         "isVid" : false,
         "ctg"   : 'eilat-negev',
          "id"    : 'Negev_Description'
        },
        // {
        //  "title":"One Day in Eilat",
        //  "sml_desc":"",
        //  "desc":"",
        //  "img":"/PostCarousel/one-day-in-eilat.jpg",
        //  "side_img":"/PostCarousel/one-day-in-eilat.jpg",
        //  "read_more":"READ MORE",
        //  "link": "/Posts/index.php?post=One_Day_In_Eilat", 
        //  "css_class":"unic-post-one-day-in-eilat",
        //  "isVid" : false,
        //  "ctg"   : 'eilat-negev',
        //   "id"    : 'One_Day_In_Eilat'
        // },
        {
         "title":"НЕГЕВ",
         "sml_desc":"",
         "desc":"",
         "img":"/PostCarousel/majestic-desert.jpg",
         "side_img":"/PostCarousel/majestic-desert.jpg",
         "read_more":"READ MORE",
         "link": "/Posts/index.php?post=Majestic_Desert", 
         "css_class":"unic-post-majestic-desert",
         "isVid" : false,
         "forVidPage": true,
         "ctg"   : 'eilat-negev',
          "id"    : 'Majestic_Desert'
        },
        // {
        //  "title":"Negev",
        //  "sml_desc":"",
        //  "desc":"",
        //  "img":"/PostCarousel/negev.jpg",
        //  "side_img":"/PostCarousel/negev.jpg",
        //  "read_more":"READ MORE",
        //  "link": "/Posts/index.php?post=Negev1", 
        //  "css_class":"unic-post-negev",
        //  "isVid" : false,
        //  "ctg"   : 'eilat-negev',
        //   "id"    : 'Negev1'
        // },
        // {
        //  "title":"LOCATION AND APPROACH",
        //  "sml_desc":"",
        //  "desc":"",
        //  "img":"/PostCarousel/location-and-approach.jpg",
        //  "side_img":"/PostCarousel/location-and-approach.jpg",
        //  "read_more":"READ MORE",
        //  "link": "/Posts/index.php?post=Location_And_Approach", 
        //  "css_class":"unic-post-location-and-approach",
        //  "isVid" : false,
        //  "ctg"   : 'eilat-negev',
        //   "id"    : 'Location_And_Approach'
        // },
        // {
        //  "title":"STAY IN THE NEGEV",
        //  "sml_desc":"",
        //  "desc":"",
        //  "img":"/PostCarousel/stay-in-the-negev.jpg",
        //  "side_img":"/PostCarousel/stay-in-the-negev.jpg",
        //  "read_more":"READ MORE",
        //  "link": "/Posts/index.php?post=Stay_In_The_Negev", 
        //  "css_class":"unic-post-stay-in-the-negev",
        //  "isVid" : false,
        //  "ctg"   : 'eilat-negev',
        //   "id"    : 'Stay_In_The_Negev'
        // },
        // {
        //  "title":"Pure Desert Magic",
        //  "sml_desc":"",
        //  "desc":"",
        //  "img":"/PostCarousel/pure-desert-magic.jpg",
        //  "side_img":"/PostCarousel/pure-desert-magic.jpg",
        //  "read_more":"READ MORE",
        //  "link": "/Posts/index.php?post=Pure_Desert_Magic", 
        //  "css_class":"unic-post-pure-desert-magic",
        //  "isVid" : false,
        //  "ctg"   : 'eilat-negev',
        //   "id"    : 'Pure_Desert_Magic'
        // },
        {
         "title":"АКТИВНЫЙ ОТДЫХ В ИЗРАИЛЬСКОЙ ПУСТЫНЕ",
         "sml_desc":"",
         "desc":"",
         "img":"/PostCarousel/action-fun-in-the-desert.jpg",
         "side_img":"/PostCarousel/action-fun-in-the-desert.jpg",
         "read_more":"READ MORE",
         "link": "/Posts/index.php?post=Action_Fun_In_The_Desert", 
         "css_class":"unic-post-action-fun-in-the-desert",
         "isVid" : false,
         "forVidPage": true,
         "ctg"   : 'eilat-negev',
          "id"    : 'Action_Fun_In_The_Desert'
        },
        
        {
         "title":"ПУТЬ БЛАГОВОНИЙ",
         "sml_desc":"",
         "desc":"",
         "img":"/PostCarousel/the-incense-route.jpg",
         "side_img":"/PostCarousel/the-incense-route.jpg",
         "read_more":"READ MORE",
         "link": "/Posts/index.php?post=The_Incense_Route", 
         "css_class":"unic-post-the-incense-route",
         "isVid" : false,
         "forVidPage": true,
         "ctg"   : 'eilat-negev',
          "id"    : 'The_Incense_Route'
        },
        // {
        //  "title":"Mount Karkom",
        //  "sml_desc":"",
        //  "desc":"",
        //  "img":"/PostCarousel/mount-karkom.jpg",
        //  "side_img":"/PostCarousel/mount-karkom.jpg",
        //  "read_more":"READ MORE",
        //  "link": "/Posts/index.php?post=Mount_Karkom", 
        //  "css_class":"unic-post-mount-karkom",
        //  "isVid" : false,
        //  "ctg"   : 'eilat-negev',
        //   "id"    : 'Mount_Karkom'
        // },
        {
         "title":"МАХТЕШ РАМОН",
         "sml_desc":"",
         "desc":"",
         "img":"/PostCarousel/machtes-ramon.jpg",
         "side_img":"/PostCarousel/machtes-ramon.jpg",
         "read_more":"READ MORE",
         "link": "/Posts/index.php?post=Machtesh_Ramon", 
         "css_class":"unic-post-machtes-ramon",
         "isVid" : false,
         "ctg"   : 'eilat-negev',
          "id"    : 'Machtesh_Ramon'
        },
        {
         "title":"АРАВА",
         "sml_desc":"",
         "desc":"",
         "img":"/PostCarousel/ha-arava.jpg",
         "side_img":"/PostCarousel/ha-arava.jpg",
         "read_more":"READ MORE",
         "link": "/Posts/index.php?post=Ha_Arava", 
         "css_class":"unic-post-ha-arava",
         "isVid" : false,
         "ctg"   : 'eilat-negev',
          "id"    : 'Ha_Arava'
        },
        {
         "title" :"МАСАДА",
         "sml_desc":"",
         "desc":"",
         "img":"/PostCarousel/epic-masada.jpg",
         "side_img":"/PostCarousel/epic-masada.jpg",
         "read_more":"READ MORE",
         "link": "/Posts/index.php?post=Epic_Masada", 
         "css_class":"unic-post-epic-masada",
         "isVid" : false,
         "forVidPage": true,
         "ctg"   : 'eilat-negev',
          "id"    : 'Epic_Masada'
        },
        // {
        //  "title":"The Bedouin Experience",
        //  "sml_desc":"",
        //  "desc":"",
        //  "img":"/PostCarousel/the-bedouin-experience.jpg",
        //  "side_img":"/PostCarousel/the-bedouin-experience.jpg",
        //  "read_more":"READ MORE",
        //  "link": "/Posts/index.php?post=The_Bedouin_Experience", 
        //  "css_class":"unic-post-the-bedouin-experience",
        //  "isVid" : false,
        //  "ctg"   : 'eilat-negev',
        //   "id"    : 'The_Bedouin_Experience'
        // },
        // {
        //  "title":"The Israel National Trail",
        //  "sml_desc":"",
        //  "desc":"",
        //  "img":"/PostCarousel/the-israel-national-trail.jpg",
        //  "side_img":"/PostCarousel/the-israel-national-trail.jpg",
        //  "read_more":"READ MORE",
        //  "link": "/Posts/index.php?post=The_Israel_National_Trail", 
        //  "css_class":"unic-post-the-israel-national-trail",
        //  "isVid" : false,
        //  "ctg"   : 'eilat-negev',
        //   "id"    : 'The_Israel_National_Trail'
        // },
        {
         "title":"ПАРК ТИМНА",
         "sml_desc":"",
         "desc":"",
         "img":"/PostCarousel/timna-treasures.jpg",
         "side_img":"/PostCarousel/timna-treasures.jpg",
         "read_more":"READ MORE",
         "link": "/Posts/index.php?post=Timna_Treasures", 
         "css_class":"unic-post-timna-treasures",
         "isVid" : false,
         "forVidPage": true,
         "ctg"   : 'eilat-negev',
          "id"    : 'Timna_Treasures'
        },
        {
         "title":"ПУСТЫНЯ НЕГЕВ",
         "sml_desc":"",
         "desc":"",
         "img":"/PostCarousel/negev-desert-dont-miss.jpg",
         "side_img":"/PostCarousel/negev-desert-dont-miss.jpg",
         "read_more":"READ MORE",
         "link": "/Posts/index.php?post=Negev_Desert_Dont_Miss", 
         "css_class":"unic-post-negev-desert-dont-miss",
         "isVid" : false,
         "ctg"   : 'eilat-negev',
          "id"    : 'Negev_Desert_Dont_Miss'
        },
        // {
        //  "title":"NEGEV CHARMS",
        //  "sml_desc":"",
        //  "desc":"",
        //  "img":"/PostCarousel/negev-charms.jpg",
        //  "side_img":"/PostCarousel/negev-charms.jpg",
        //  "read_more":"READ MORE",
        //  "link": "/Posts/index.php?post=Negev_Charms", 
        //  "css_class":"unic-post-negev-charms",
        //  "isVid" : false,
        //  "ctg"   : 'eilat-negev',
        //   "id"    : 'Negev_Charms'
        // },
        // End Eilat Posts


        // North Posts
        // {
        //  "title":"Galilee",
        //  "sml_desc":"",
        //  "desc":"",
        //  "img":"/PostCarousel/galilee.jpg",
        //  "side_img":"/PostCarousel/galilee.jpg",
        //  "read_more":"READ MORE",
        //  "link": "/Posts/index.php?post=Galilee", 
        //  "css_class":"unic-post-galilee",
        //  "isVid" : false,
        //  "ctg"   : 'north',
        //   "id"    : 'Galilee'
        // },

        
        {
         "title":"СОКРОВИЩА ГАЛИЛЕИ",
         "sml_desc":"",
         "desc":"",
         "img":"/PostCarousel/treasures-of-galilea.jpg",
         "side_img":"/PostCarousel/treasures-of-galilea.jpg",
         "read_more":"READ MORE",
         "link": "/Posts/index.php?post=treasures-of-galilea", 
         "css_class":"unic-post-Treasures_Of_Galilea",
         "isVid" : false,
         "ctg"   : 'culinarynorth',
          "id"    : 'Treasures_Of_Galilea'
        },
        {
         "title":"КЕСАРИЯ",
         "sml_desc":"",
         "desc":"",
         "img":"/PostCarousel/caesarea.jpg",
         "side_img":"/PostCarousel/caesarea.jpg",
         "read_more":"READ MORE",
         "link": "/Posts/index.php?post=Caesarea", 
         "css_class":"unic-post-caesarea",
         "isVid" : false,
         "forVidPage": true,
         "ctg"   : 'north',
          "id"    : 'Caesarea'
        },
        {
         "title":"СТАРЫЙ АККО ",
         "sml_desc":"",
         "desc":"",
         "img":"/PostCarousel/acre.jpg",
         "side_img":"/PostCarousel/acre.jpg",
         "read_more":"READ MORE",
         "link": "/Posts/index.php?post=Acre", 
         "css_class":"unic-post-acre",
         "isVid" : false,
         "forVidPage": true,
         "ctg"   : 'north',
          "id"    : 'Acre'
       },
        {
         "title":"ХАЙФА",
         "sml_desc":"",
         "desc":"",
         "img":"/PostCarousel/haifa.jpg",
         "side_img":"/PostCarousel/haifa.jpg",
         "read_more":"READ MORE",
         "link": "/Posts/index.php?post=Haifa", 
         "css_class":"unic-post-haifa",
         "isVid" : false,
         "forVidPage": true,
         "ctg"   : 'north',
          "id"    : 'Haifa'
        },
        {
         "title":"ЦФАТ",
         "sml_desc":"",
         "desc":"",
         "img":"/PostCarousel/safed.jpg",
         "side_img":"/PostCarousel/safed.jpg",
         "read_more":"READ MORE",
         "link": "/Posts/index.php?post=Safed", 
         "css_class":"unic-post-safed",
         "isVid" : false,
         "forVidPage": true,
         "ctg"   : 'north',
          "id"    : 'Safed'
        },
        // {
        //  "title":"THE STUNNING BAHA’I GARDENS",
        //  "sml_desc":"",
        //  "desc":"",
        //  "img":"/PostCarousel/bahai-gardens.jpg",
        //  "side_img":"/PostCarousel/bahai-gardens.jpg",
        //  "read_more":"READ MORE",
        //  "link": "/Posts/index.php?post=The_Bahai_Gardens", 
        //  "css_class":"unic-post-bahai-gardens",
        //  "isVid" : false,
        //  "ctg"   : 'north',
        //   "id"    : 'The_Bahai_Gardens'
        // },
        {
         "title":"КИННЕРЕТ",
         "sml_desc":"",
         "desc":"",
         "img":"/PostCarousel/sea-of-galilee.jpg",
         "side_img":"/PostCarousel/sea-of-galilee.jpg",
         "read_more":"READ MORE",
         "link": "/Posts/index.php?post=The_Sea_Of_Galilee", 
         "css_class":"unic-post-sea-of-galilee",
         "isVid" : false,
         "forVidPage": true,
         "ctg"   : 'north',
          "id"    : 'The_Sea_Of_Galilee'
        },
        {
         "title":"РОШ-ПИННА",
         "sml_desc":"",
         "desc":"",
         "img":"/PostCarousel/rosh-pina.jpg",
         "side_img":"/PostCarousel/rosh-pina.jpg",
         "read_more":"READ MORE",
         "link": "/Posts/index.php?post=Rosh_Pina", 
         "css_class":"unic-post-rosh-pina",
         "isVid" : false,
         "forVidPage": true,
         "ctg"   : 'north',
          "id"    : 'Rosh_Pina'
        },
        {
         "title":"НАЗАРЕТ КОЛЫБЕЛЬ ХРИСТИАНСТВА",
         "sml_desc":"",
         "desc":"",
         "img":"/PostCarousel/nazareth.jpg",
         "side_img":"/PostCarousel/nazareth.jpg",
         "read_more":"READ MORE",
         "link": "/Posts/index.php?post=Nazareth_Christian_Cradle", 
         "css_class":"unic-post-nazareth",
         "isVid" : false,
         "forVidPage": true,
         "ctg"   : 'north',
          "id"    : 'Nazareth_Christian_Cradle'
        },


        // {
        //  "title":"Cheers to Israel",
        //  "sml_desc":"",
        //  "desc":"",
        //  "img":"/PostCarousel/cheers-to-israel.jpg",
        //  "side_img":"/PostCarousel/cheers-to-israel.jpg",
        //  "read_more":"READ MORE",
        //  "link": "/Posts/index.php?post=Cheers_To_Israel", 
        //  "css_class":"unic-post-cheers-to-israel",
        //  "isVid" : false,
        //  "ctg"   : 'north',
        //   "id"    : 'Cheers_To_Israel'
        // },
       
        {
         "title":"Гастрономические каникулы в Галилее",
         "sml_desc":"",
         "desc":"",
         "img":"/PostCarousel/galilean-treat.jpg",
         "side_img":"/PostCarousel/galilean-treat.jpg",
         "read_more":"READ MORE",
         "link": "/Posts/index.php?post=A_Galilean_Treat", 
         "css_class":"unic-post-galilean-treat",
         "isVid" : false,
         "forVidPage": true,
         "ctg"   : 'culinarynorth',
          "id"    : 'A_Galilean_Treat'
        },
        {
         "title":"ГАЛИЛЕЯ ПРЯМО ПО КУРСУ",
         "sml_desc":"",
         "desc":"",
         "img":"/PostCarousel/galilee-action.jpg",
         "side_img":"/PostCarousel/galilee-action.jpg",
         "read_more":"READ MORE",
         "link": "/Posts/index.php?post=Galilee_Action", 
         "css_class":"unic-post-galilee-action",
         "isVid" : false,
         "forVidPage": true,
         "ctg"   : 'north',
          "id"    : 'Galilee_Action'
        },
        {
         "title":"НАЗАРЕТ",
         "sml_desc":"",
         "desc":"",
         "img":"/PostCarousel/nazareth2.jpg",
         "side_img":"/PostCarousel/nazareth2.jpg",
         "read_more":"READ MORE",
         "link": "/Posts/index.php?post=Nazareth", 
         "css_class":"unic-post-nazareth2",
         "isVid" : false,
         "forVidPage": true,
         "ctg"   : 'north',
          "id"    : 'Nazareth'
        },
        // {
        //  "title":"Bet She’an",
        //  "sml_desc":"",
        //  "desc":"",
        //  "img":"/PostCarousel/bet-shean.jpg",
        //  "side_img":"/PostCarousel/bet-shean.jpg",
        //  "read_more":"READ MORE",
        //  "link": "/Posts/index.php?post=Bet_Shean", 
        //  "css_class":"unic-post-bet-shean",
        //  "isVid" : false,
        //  "ctg"   : 'north',
        //   "id"    : 'Bet_Shean'
        // },
        
        // {
        //  "title":"Zichron Ya’akov",
        //  "sml_desc":"",
        //  "desc":"",
        //  "img":"/PostCarousel/zichron-yaakov.jpg",
        //  "side_img":"/PostCarousel/zichron-yaakov.jpg",
        //  "read_more":"READ MORE",
        //  "link": "/Posts/index.php?post=Zichron_Yaakov", 
        //  "css_class":"unic-post-zichron-yaakov",
        //  "isVid" : false,
        //  "ctg"   : 'north',
        //   "id"    : 'Zichron_Yaakov'
        // },
        // {
        //  "title":"Discover the Wine Routes",
        //  "sml_desc":"",
        //  "desc":"",
        //  "img":"/PostCarousel/discover-the-wine-routes.jpg",
        //  "side_img":"/PostCarousel/discover-the-wine-routes.jpg",
        //  "read_more":"READ MORE",
        //  "link": "/Posts/index.php?post=Discover_The_Wine_Routes", 
        //  "css_class":"unic-post-discover-the-wine-routes",
        //  "isVid" : false,
        //  "ctg"   : 'north',
        //   "id"    : 'Discover_The_Wine_Routes'
        // },
        
        {
         "title":"ОЗЕРО ХУЛА",
         "sml_desc":"",
         "desc":"",
         "img":"/PostCarousel/birdtastic-hula-lake.jpg",
         "side_img":"/PostCarousel/birdtastic-hula-lake.jpg",
         "read_more":"READ MORE",
         "link": "/Posts/index.php?post=Birdtastic_Hula_Lake", 
         "css_class":"unic-post-birdtastic-hula-lake",
         "isVid" : false,
         "forVidPage": true,
         "ctg"   : 'north',
          "id"    : 'Birdtastic_Hula_Lake'
        },
        // {
        //  "title":"THE INCOMPARABLE KIBBUTZ EXPERIENCE",
        //  "sml_desc":"",
        //  "desc":"",
        //  "img":"/PostCarousel/kibbutz-experience.jpg",
        //  "side_img":"/PostCarousel/kibbutz-experience.jpg",
        //  "read_more":"READ MORE",
        //  "link": "/Posts/index.php?post=The_Kibbutz_Experience", 
        //  "css_class":"unic-post-kibbutz-experience",
        //  "isVid" : false,
        //  "ctg"   : 'north',
        //   "id"    : 'The_Kibbutz_Experience'
        // },
        // {
        //  "title":"NATIONAL PARKS",
        //  "sml_desc":"",
        //  "desc":"",
        //  "img":"/PostCarousel/national-parks.jpg",
        //  "side_img":"/PostCarousel/national-parks.jpg",
        //  "read_more":"READ MORE",
        //  "link": "/Posts/index.php?post=National_Parks", 
        //  "css_class":"unic-post-national-parks",
        //  "isVid" : false,
        //  "ctg"   : 'north',
        //   "id"    : 'National_Parks'
        // },
        
        // {
        //  "title":"Tiberias (Tverya)",
        //  "sml_desc":"",
        //  "desc":"",
        //  "img":"/PostCarousel/tiberias.jpg",
        //  "side_img":"/PostCarousel/tiberias.jpg",
        //  "read_more":"READ MORE",
        //  "link": "/Posts/index.php?post=Tiberias", 
        //  "css_class":"unic-post-tiberias",
        //  "isVid" : false,
        //  "ctg"   : 'north',
        //   "id"    : 'Tiberias'
        // },

        
        // This  post is for complite the 4 post in carousel in mobile for JERUSALEM carousel
        {
           "title": "ИЕРУСАЛИМ-ЦЕНТР ИСКУССТВА",
            "sml_desc" : "",
            "desc" : "",
            "img": "/PostCarousel/Jerusalem/jerusalem-art.jpg",
            "side_img": "/PostCarousel/Jerusalem/jerusalem-art.jpg",
            "read_more": "Прочитать больше",
            "link": "/Posts/index.php?post=Jerusalem_Arts",
            "isVid": false,
            "isDouble": true,
            "ctg": "jerusalem",
            "id": "Jerusalem_Arts"
        },
        // End This  post is for complite the 4 post in carousel in mobile for JERUSALEM carousel



        // This  post is for complite the 4 post in carousel in mobile for TEL AVIV carousel
        {
            "title": "Сарона в Тель-Авиве",
            "desc": "",
            "sml_desc": "",
            "img": "Videos/d.jpg",
            "img_mob":"/Videos/video_mob/d.jpg",
            "side_img": "Videos/sidebar/d.jpg",
            "read_more": "Прочитать больше",
            "link": "/Posts/index.php?postType=video&post=Sarona_TelAviv",
            "vidId": "bWY_8bHq3as",
            "ctg": "telaviv",
            "isVid": true,
            "forVidPage": true,
            "isDouble": true,
            "id": "Sarona_TelAviv"
        },
        // End This  post is for complite the 4 post in carousel in mobile for TEL AVIV carousel

        // These tree posts is for complite the 4 post in carousel in mobile for CULINARY carousel
        {
            "title": "КОФЕЙНАЯ ЖИЗНЬ ТЕЛЬ-АВИВА",
            // "sml_desc": "Tel Aviv over a fresh coffee",
            "sml_desc": "",
            // "desc": "Coffee shop culture is fundamental",
            "desc":" ",
            "img": "Videos/coffee.jpg",
             "img_mob":"/Videos/video_mob/coffee.jpg",
            "side_img": "Videos/sidebar/coffee.jpg",
            "read_more": "Прочитать больше",
            "link": "/Posts/index.php?postType=video&post=16",
            "vidId": "rVr0gqFC364",
            "ctg": "culinarytelaviv",
            "isVid": true,
            "forVidPage": true,
            "isDouble": true,
            "id": "Coffee_In_TelAviv"
        },
        {
            "title": "Центр кулинарного искусства",
            // "sml_desc": "Пробудите свои вкусовые<br> рецепторы в Тель-Авиве",
            "sml_desc": "",
            // "desc": "Тель-Авив предлагает огромный<br> выбор великолепных ресторанов",
            "desc": "",
            "img": "Videos/e.jpg",
            "img_mob":"/Videos/video_mob/e.jpg",
            "side_img": "Videos/sidebar/e.jpg",
            "read_more": "Прочитать больше",
            "link": "/Posts/index.php?postType=video&post=33",
            "vidId": "jfyHxk8ZRrI",
            "ctg": "culinarytelaviv",
            "isVid": true,
            "forVidPage": true,
            "isDouble": true,
            "id": "Gourmet_TelAviv"
        },
        {
            "title": "ВРЕМЯ ШАКШУКИ",
            // "sml_desc": "Познакомьтесь с удивительной <br>кулинарной сценой Тель-Авива",
            "sml_desc": "",
            "desc": "",
            "img": "/PostCarousel/22.jpg",
            "side_img": "/PostCarousel/22.jpg",
            "read_more": "Прочитать больше",
            "link": "/Posts/index.php?post=Shakshuka_Time",
            "isVid": true,
            "forVidPage": true,
            "isDouble": true,
            "ctg": "culinary",
            "vidId":"n4kCnPXEX7g",
            "id": "Shakshuka_Time"
        },
        // End These tree posts is for complite the 4 post in carousel in mobile for CULINARY carousel

        // End These two posts is for complite the 4 post in carousel in mobile for NEGEV AND EILAT carousel
        {
         "title":"НЕГЕВ ПОБЕГ В ПУСТЫНЮ",
         "sml_desc":"",
         "desc":"",
         "img":"/PostCarousel/negev-description.jpg",
         "side_img":"/PostCarousel/negev-description.jpg",
         "read_more":"READ MORE",
         "link": "/Posts/index.php?post=Negev_Description", 
         "css_class":"unic-post-negev-description",
         "isVid" : false,
         "isDouble": true,
         "ctg"   : 'eilat-negev',
          "id"    : 'Negev_Description'
        },
        {
         "title":"АРАВА",
         "sml_desc":"",
         "desc":"",
         "img":"/PostCarousel/ha-arava.jpg",
         "side_img":"/PostCarousel/ha-arava.jpg",
         "read_more":"READ MORE",
         "link": "/Posts/index.php?post=Ha_Arava", 
         "css_class":"unic-post-ha-arava",
         "isVid" : false,
         "isDouble": true,
         "ctg"   : 'eilat-negev',
          "id"    : 'Ha_Arava'
        },
        
        // End These two posts is for complite the 4 post in carousel in mobile for NEGEV AND EILAT carousel
        

        {
         "title":"Гастрономические каникулы в Галилее",
         "sml_desc":"",
         "desc":"",
         "img":"/PostCarousel/galilean-treat.jpg",
         "side_img":"/PostCarousel/galilean-treat.jpg",
         "read_more":"READ MORE",
         "link": "/Posts/index.php?post=A_Galilean_Treat", 
         "css_class":"unic-post-galilean-treat",
         "isVid" : false,
         "forVidPage": true,
         "isDouble": true,
         "ctg"   : 'culinarynorth',
          "id"    : 'A_Galilean_Treat'
        },
        {
         "title":"СОКРОВИЩА ГАЛИЛЕИ",
         "sml_desc":"",
         "desc":"",
         "img":"/PostCarousel/treasures-of-galilea.jpg",
         "side_img":"/PostCarousel/treasures-of-galilea.jpg",
         "read_more":"READ MORE",
         "link": "/Posts/index.php?post=treasures-of-galilea", 
         "css_class":"unic-post-Treasures_Of_Galilea",
         "isVid" : false,
         "isDouble": true,
         "ctg"   : 'culinarynorth',
          "id"    : 'Treasures_Of_Galilea'
        },

        {
         "title":"ЦФАТ",
         "sml_desc":"",
         "desc":"",
         "img":"/PostCarousel/safed.jpg",
         "side_img":"/PostCarousel/safed.jpg",
         "read_more":"READ MORE",
         "link": "/Posts/index.php?post=Safed", 
         "css_class":"unic-post-safed",
         "isVid" : false,
         "forVidPage": true,
         "isDouble": true,
         "ctg"   : 'north',
          "id"    : 'Safed'
        },
        {
         "title":"СТАРЫЙ АККО ",
         "sml_desc":"",
         "desc":"",
         "img":"/PostCarousel/acre.jpg",
         "side_img":"/PostCarousel/acre.jpg",
         "read_more":"READ MORE",
         "link": "/Posts/index.php?post=Acre", 
         "css_class":"unic-post-acre",
         "isVid" : false,
         "forVidPage": true,
         "isDouble": true,
         "ctg"   : 'north',
          "id"    : 'Acre'
       },
] 

export const TouristInfoPosts = [


        {
         "title":"ЧТО ВЗЯТЬ С СОБОЙ",
         "sml_desc":"",
         "desc":"",
         "img":"/PostCarousel/what-to-pack.jpg",
         "side_img":"/PostCarousel/what-to-pack.jpg",
         "read_more":"Прочитать больше",
         "link": "/Posts/index.php?post=20", 
         "css_class":"unic-post-what-to-pack",
         "isVid" : false,
         "ctg"   : 'TouristInfo',
          "id"    : 'What_To_Pack'
        },
        {
         "title":"ЭЛЕКТРОПРИБОРАМИ",
         "sml_desc":"",
         "desc":"",
         "img":"/PostCarousel/electrical-appliances.jpg",
         "side_img":"/PostCarousel/electrical-appliances.jpg",
         "read_more":"Прочитать больше",
         "link": "/Posts/index.php?post=20", 
         "css_class":"unic-post-electrical-appliances",
         "isVid" : false,
         "ctg"   : 'TouristInfo',
          "id"    : 'Electrical_Appliances'
        },
        // {
        //  "title":"Weather",
        //  "sml_desc":"",
        //  "desc":"",
        //  "img":"/PostCarousel/weather.jpg",
        //  "side_img":"/PostCarousel/weather.jpg",
        //  "read_more":"Прочитать больше",
        //  "link": "/Posts/index.php?post=20", 
        //  "css_class":"unic-post-weather",
        //  "isVid" : false,
        //  "ctg"   : 'TouristInfo',
        //   "id"    : 'Weather'
        // },
        {
         "title":"ТРАНСПОРТ",
         "sml_desc":"",
         "desc":"",
         "img":"/PostCarousel/transportation.jpg",
         "side_img":"/PostCarousel/transportation.jpg",
         "read_more":"Прочитать больше",
         "link": "/Posts/index.php?post=20", 
         "css_class":"unic-post-transportation",
         "isVid" : false,
         "ctg"   : 'TouristInfo',
          "id"    : 'Transportation'
        },
        {
         "title":"ЧАСТО ЗАДАВАЕМЫЕ ВОПРОСЫ",
         "sml_desc":"",
         "desc":"",
         "img":"/PostCarousel/faq.jpg",
         "side_img":"/PostCarousel/faq.jpg",
         "read_more":"Прочитать больше",
         "link": "/Posts/index.php?post=20", 
         "css_class":"unic-post-faq",
         "isVid" : false,
         "ctg"   : 'TouristInfo',
          "id"    : 'Frequently_Asked_Questions'
        },
       
        // {
        //  "title":"Israeli Currency",
        //  "sml_desc":"",
        //  "desc":"",
        //  "img":"/PostCarousel/israeli-currency.jpg",
        //  "side_img":"/PostCarousel/israeli-currency.jpg",
        //  "read_more":"Прочитать больше",
        //  "link": "/Posts/index.php?post=20", 
        //  "css_class":"unic-post-israeli-currency",
        //  "isVid" : false,
        //  "ctg"   : 'TouristInfo',
        //   "id"    : 'Israeli_Currency'
        // },
        // {
        //  "title":"Immigration Customs",
        //  "sml_desc":"",
        //  "desc":"",
        //  "img":"/PostCarousel/immigration-customs.jpg",
        //  "side_img":"/PostCarousel/immigration-customs.jpg",
        //  "read_more":"Прочитать больше",
        //  "link": "/Posts/index.php?post=20", 
        //  "css_class":"unic-post-immigration-customs",
        //  "isVid" : false,
        //  "ctg"   : 'TouristInfo',
        //   "id"    : 'Immigration_Customs'
        // },
        {
         "title":"ПАСПОРТА, ВИЗЫ, ETA",
         "sml_desc":"",
         "desc":"",
         "img":"/PostCarousel/Passports-visa.jpg",
         "side_img":"/PostCarousel/Passports-visa.jpg",
         "read_more":"Прочитать больше",
         "link": "/Posts/index.php?post=20", 
         "css_class":"unic-post-Passports-visa",
         "isVid" : false,
         "ctg"   : 'TouristInfo',
          "id"    : 'Passports_Visa'
        },
        {
          "title":"НАПРАВЛЕНИЕ ДЛЯ ВСЕХ И КАЖДОГО",
          "sml_desc":"",
          "desc":"",
          "img":"/PostCarousel/PlanYourTrip/destination-for-all.jpg",
          "side_img":"/PostCarousel/PlanYourTrip/destination-for-all.jpg",
          "read_more":"READ MORE",
          "link": "/Posts/index.php?post=20", 
          "css_class":"unic-post-Passports-visa",
          "isVid" : false,
          "ctg"   : 'TouristInfo',
           "id"    : 'Destination_For_All'
         },

]

export const Reminders = [

       // Tel Aviv
      {
        "quote": "One of the world's 25 best cities for foodies",
        "site": "Business Insider",
        "img": "/References/1.jpg",
        "ctg": "Tel Aviv",

       
      },

      // Jerusalem
      {
        "quote": "TripAdvisor Traveler's Choice Award 2015",
        "site": "TripAdvisor",
        "img": "/References/9.jpg",
        "ctg": "Jerusalem",
       
      },

      {
        "quote": "One of the world's leading party cities",
        "site": "Telegraph",
        "img": "/References/2.jpg",
        "ctg": "Tel Aviv",
       
      },
      

      {
        "quote": "One of the cities with most beautiful people",
        "site": "Conde Nast",
        "img": "/References/3.jpg",
        "ctg": "Tel Aviv",
       
      },

      {
        "quote": "One of the 20 must visit destinations in the world  TNS",
        "site": "The National Student",
        "img": "/References/10.jpg",
        "ctg": "Jerusalem",
       
      },

      {
        "quote": "One of the best beach party spots on the planet",
        "site": "USA Today",
        "img": "/References/4.jpg",
        "ctg": "Tel Aviv",
       
      },
      {
        "quote": "One of the world's top 10 beach cities",
        "site": "National Geographic",
        "img": "/References/5.jpg",
        "ctg": "Tel Aviv",
       
      },

      {
        "quote": "3rd Of 6 Top world’s holiest sites",
        "site": "National Geographic",
        "img": "/References/11.jpg",
        "ctg": "Jerusalem",
       
      },

      {
        "quote": "One of the world's top ten cities",
        "site": "Lonely Planet",
        "img": "/References/6.jpg",
        "ctg": "Tel Aviv",
       
      },
      {
        "quote": "One of the world's top ten hedonistic city breaks ",
        "site": "Lonely Planet",
        "img": "/References/7.jpg",
        "ctg": "Tel Aviv",
       
      },
      {
        "quote": "I just thought it was magical… It instantly turned into my favorite trip.",
        "site": "TripAdvisor",
        "img": "/References/12.jpg",
        "ctg": "Jerusalem",
        "job" : "CEO, Stephen Kaufer about Jerusalem" ,
        "cssClass" : "make-it-smller"
      },

      {
        "quote": "The World’s New Dining Hotspot",
        "site": "Bloomberg.com",
        "img": "/References/8.jpg",
        "ctg": "Tel Aviv",
       
      },

      

]







// WEBPACK FOOTER //
// ./src/Data/Data.js